import React, {
  useState,
  useMemo,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { v4 as uuidv4 } from "uuid";
import { useDropzone } from "react-dropzone";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Navlogo from "../../assets/images/logo/NavLogo.png";

import { ThemeProvider } from "@mui/material/styles";
import { useForm } from "react-hook-form";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import pdfMake from "pdfmake/build/pdfmake";
import axios from "axios";
import { displayPatientName } from "../../utils/displayPatientName";
import { displayDoctorName } from "../../utils/displayDoctorName";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Room from "../../components/VideoConf/Room";
import {
  List,
  ListItemText,
  Divider,
  Drawer,
  IconButton,
  Switch,
  Modal,
  Box,
  Snackbar,
  Alert,
  Tooltip,
  Fab,
  Typography,
  Grid,
  ListItemButton,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  styled,
  Card,
  Zoom,
  TextField,
  Collapse,
  Stack,
  ListItem,
  Popover,
  MenuItem,
  Menu,
  Tab,
  Tabs,
} from "@mui/material";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import JoditEditor from "jodit-react";
import "./DoctorConsole.scss";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import AbdmRecords from "./AbdmRecords/AbdmRecords";
import { CheckToken } from "../login/AccessToken";
import PastVisits from "./PastVisits/PastVisits";
import TimelineMain from "../../components/Timeline/TimelineMain";
import dayjs from "dayjs";
import {
  StyledButton,
  theme,
  DoctorconsoleGrid,
  StyledAccordion,
  InnerStyledAccordion,
} from "./StyledComponents";
import { toast } from "react-toastify";
import Disclaimer from "./Utils/Disclaimer";
import FamilyHistory from "./HistoriesData/FamilyHistory";
import AllergyIntolerance from "./HistoriesData/AllergyIntolerance";
import AddictionHistory from "./HistoriesData/AddictionHistory";
import DrugHistory from "./HistoriesData/DrugHistory";
import MenstrualHistory from "./HistoriesData/MenstrualHistory";
import MedicalHistory from "./HistoriesData/MedicalHistory";
import SurgicalHistory from "./HistoriesData/SurgicalHistory";
import {
  extractTimeFromDateString,
  formatDateTime,
  formatDateYYYYMMDD,
  renderEachSection,
  SwitchWithLabel,
} from "./Utils/UtilsFunctions";
import PdfFooter from "./PdfDatas/PdfFooter";
import {
  adviceData,
  appointmentData,
  examinationsData,
  examinationsHistoryData,
  otherSectionsData,
} from "./Utils/SectionsDataMap";
import DoctorconsoleHeader from "./Utils/DoctorconsoleHeader";
import ChiefComplaint from "./Sections/ChiefComplaint";
import Examinations from "./Sections/Examinations";
import Diagnosis from "./Sections/Diagnosis";
import AdultVaccination from "./Sections/AdultVaccination";
import AdultVaccinationHistory from "./HistoriesData/AdultVaccinationHistory";
import Investigations from "./Sections/Investigations";
import Procedures from "./Sections/Procedures";
import Medications from "./Sections/Medications";
import Attachments from "./Sections/Attachments";
import { initialSuggestions } from "./initialData/initialData";
import { formatDurationTextForDisplay } from "./HistoriesData/durationUtils";
import {
  DoctorConsoleConfigProvider,
  loadDoctorConsoleConfig,
  buildMedicalBackgroundInitial,
  getDefaultActiveSectionKey,
  useDoctorConsoleRemoteConfig,
  buildRuleContext,
  isFeatureEnabled,
} from "./config";
import { normalizeDoctorId } from "./config/api/doctorConsoleConfigApi";
import DoctorConsoleSectionsList from "./config/renderers/DoctorConsoleSectionsList";
import PdfHeaderDocs from "./PdfDatas/PdfHeaderDocs";
import Referral from "./Sections/Referral";
import FollowUp from "./Sections/FollowUp";
import FollowUpReferralComp from "./Sections/FollowUpReferralComp";
import DrawingPad from "./Utils/DrawingPad";
import AlertDialog from "../../components/Utils/AlertDialog";
import InitialObservation from "./HistoriesData/InitialObservation";
import { filterInitialObservationForClinicalPayload } from "./HistoriesData/initialObservationUtils";
import PrintPrescription from "../../components/PrescriptionCard/PrintPrescription";
import PrintPrescriptionforButtonDropdown from "../../components/PrescriptionCard/PrintPrescForButtonDropDown";
import WellnessPdf from "../../components/PrescriptionCard/wellnessPdf";
import PrescriptionPdf from "../../components/PrescriptionCard/PrescriptionPdf";
import PrescriptionPdfPdf from "../../components/PrescriptionCard/PrescriptionPdfPdf";
import VoiceInputModal from "./Utils/VoiceInputModal";
import PatientSummaryModal from "./Utils/PatientSummaryModal";
import { styles } from "./DoctorConsole.styles";
import { ChiefComplaintTable } from "./Sections/ChiefComplaintTable";
import { DiagnosisTable } from "./Sections/DiagnosisTable";
import { AdultVaccinationTable } from "./Sections/AdultVaccinationTable";
import { InvestigationsTable } from "./Sections/InvestigationsTable";
import { ProceduresTable } from "./Sections/ProceduresTable";
import { MedicationsTable } from "./Sections/MedicationsTable";
import StarIcon from "@mui/icons-material/Star";
import Icon from "./Utils/Icons";
import PastRecordsModal from "./Utils/PastRecordsModal";
import { AttachmentsFilePreview } from "./Sections/AttachmentsFilePreview";
import MedicalAdvice from "./Sections/MedicalAdvice";
import { useHistory } from "react-router-dom";
import Patient360Modal from "./Utils/Patient360Modal";
import CaseSheetModal from "../appointments/CaseSheetModal";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import Transcription from "./Sections/Transcription";
import { usePermissions } from "../login/PermissionContext";
import { isTodayOrFuture } from "../utils/utils";
import showConfirmDialog from "../../components/ShowConfirmDialog/ShowConfirmDialog";
import { displayPatientNameFromParts } from "../../utils/displayPatientName";
import {
  DOCTOR_CONSOLE_DRAFT_KEY,
  EMPTY_SELECTED_SECTIONS_DATA,
  buildConsultationDraftData,
  clearDraftRecord,
  clearDoctorConsoleDraftIfNotOwnedBy,
  getDraftAppointmentId,
  getDraftRecord,
  isConsultationDraftContentEmpty,
  upsertDraftRecord,
} from "./doctorConsoleDraftStorage";

const doctorConsoleConfig = loadDoctorConsoleConfig();
const defaultActiveSectionKey = getDefaultActiveSectionKey(doctorConsoleConfig);

const DoctorConsole = () => {
  const history = useHistory();
  const { setValue } = useForm();
  const {
    register: register3,
    handleSubmit: handleSubmit3,
    formState: { errors: errors3 },
    setError: setError3,
    getValues: getValues3,
    setValue: setValue3,
  } = useForm();
  const { state } = useLocation();
  console.log("State in doctor's console", state);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : "",
  );
  const startTime = extractTimeFromDateString(state?.startTime);

  const { userInfo } = usePermissions();
  const facility_id = userInfo.facility_id;

  const consoleDoctorId = useMemo(
    () =>
      normalizeDoctorId(
        userInfo?.doctor_id ??
          state?.doctorData?.doctor_id ??
          sessionStorage.getItem("doctor_id"),
      ),
    [userInfo?.doctor_id, state?.doctorData?.doctor_id],
  );

  // Config for this doctor's console (logged-in doctor, or appointment doctor).
  const { config: remoteConsoleConfig } =
    useDoctorConsoleRemoteConfig(consoleDoctorId);

  const consoleConfig = useMemo(
    () => loadDoctorConsoleConfig(remoteConsoleConfig),
    [remoteConsoleConfig],
  );
  const autosaveDraftConfig = consoleConfig.features?.autosaveDraft;
  const autosaveEnabled = autosaveDraftConfig?.enabled !== false;
  const autosaveIntervalMs = Math.max(
    15000,
    autosaveDraftConfig?.intervalMs ?? 30000,
  );

  const [activeHistorySection, setActiveHistorySection] = useState("");
  const [medicalBackground, setMedicalBackground] = useState(() =>
    buildMedicalBackgroundInitial(doctorConsoleConfig),
  );
  /** Blocks 30s autosave until draft restore/hydration finishes for the current patient. */
  const hasHydratedDraftRef = useRef(false);
  /** After successful OP consultation submit: no autosave until remount (refresh / navigate back). */
  const draftAutosaveDisabledAfterSubmitRef = useRef(false);
  const updateMedicalBackground = (type, data) => {
    setMedicalBackground((prevData) => ({
      ...prevData,
      [type]: data,
    }));
  };
  console.log(
    "Medical Background From Doctor's Console page",
    medicalBackground,
  );
  const currentPatientId = state?.patientData?.patient_id;

  // Re-run draft hydration when switching patient or logged-in doctor.
  useEffect(() => {
    hasHydratedDraftRef.current = false;
    draftAutosaveDisabledAfterSubmitRef.current = false;
  }, [currentPatientId, consoleDoctorId]);

  const [isAbdmEnabled, setIsAbdmEnabled] = useState(
    sessionStorage.getItem("isAbdmEnabled") !== undefined &&
      sessionStorage.getItem("isAbdmEnabled") !== null
      ? JSON.parse(sessionStorage.getItem("isAbdmEnabled"))
      : false,
  );
  const [isAiEnabled, setIsAiEnabled] = useState(
    sessionStorage.getItem("isAiEnabled") !== undefined &&
      sessionStorage.getItem("isAiEnabled") !== null
      ? JSON.parse(sessionStorage.getItem("isAiEnabled"))
      : false,
  );
  const [timelineData, setTimelineData] = useState(null);
  const [timelineDataAbdm, setTimelineDataAbdm] = useState(null);
  const [s3MedicalBackground, setS3MedicalBackground] = useState(null);
  const [abdmMedicalBackground, setAbdmMedicalBackground] = useState(null);
  const [s3BucketFhir, setS3BucketFhir] = useState(null);
  const abdmData = state?.fhirArrData;
  const [selectedContext, setSelectedContext] = useState("");
  const [selectedContextDisplay, setSelectedContextDisplay] = useState("");
  const [selectedContextForRetrieveFhir, setSelectedContextForRetrieveFhir] =
    useState([]);
  const [addCareContextModalOpen, setAddCareContextModalOpen] = useState(false);
  const [care_context_list, setCare_context_list] = useState([]);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [previewPrescription, setPreviewPrescription] = useState(false);
  const [previewTab, setPreviewTab] = useState(1); // 0 = OP Consultation, 1 = Prescription
  const [dentalData, setDentalData] = useState([]);
  const [OpConsultationSubmited, setOpConsultationSubmited] = useState(false);
  /** Loading state for the Save Draft button (POST prescription_draft/). */
  const [isSavingPrescriptionDraft, setIsSavingPrescriptionDraft] =
    useState(false);
  /** Loading state for the Submit button, held until the whole submission chain settles. */
  const [isSubmittingPrescription, setIsSubmittingPrescription] =
    useState(false);
  /** Mirrors isSubmittingPrescription so the click guard never reads stale state. */
  const isSubmittingPrescriptionRef = useRef(false);
  const [isS3ModalOpen, setIsS3ModalOpen] = useState(false);
  console.log("dentalData-", dentalData);
  console.log("isAI-", isAiEnabled);
  const [vitals, setVitals] = useState([
    {
      name: "Temperature",
      type: "VitalSigns",
      codeDisplay: "Body surface temperature",
      value: "",
      sign: "°F",
      added: true,
      categoryDisplay: "Vital Signs",
      unit: "degree Fahrenheit",
      unitCode: "[degF]",
      lowerLimit: null,
      id: "body-temperature",
      upperLimit: null,
    },
    {
      name: "Pulse",
      type: "VitalSigns",
      value: "",
      codeDisplay: "Heart rate",
      sign: "bpm",
      added: true,
      categoryDisplay: "Vital Signs",
      unit: "beats/minute",
      unitCode: "/min",
      lowerLimit: null,
      id: "heart-rate",
      upperLimit: null,
    },
    {
      name: "Respiratory Rate",
      type: "VitalSigns",
      codeDisplay: "Respiratory rate",
      value: "",
      sign: "rpm",
      added: true,
      categoryDisplay: "Vital Signs",
      unit: "breaths/minute",
      unitCode: "/min",
      lowerLimit: null,
      id: "respiratory-rate",
      upperLimit: null,
    },
    {
      name: "BP",
      type: "VitalSigns",
      codeDisplay: "Blood pressure panel with all children optional",
      value: "",
      sign: "mmHg",
      added: true,
      categoryDisplay: "Vital Signs",
      unit: "mmHg",
      unitCode: "mm[Hg]",
      lowerLimit: "120/80",
      id: "blood-pressure",
      upperLimit: "140/90",
    },
    {
      name: "SPO2",
      type: "VitalSigns",
      codeDisplay: "Oxygen saturation in Arterial blood",
      value: "",
      sign: "%",
      added: true,
      categoryDisplay: "Vital Signs",
      unit: "%",
      unitCode: "%",
      lowerLimit: "90",
      id: "oxygen-saturation",
      upperLimit: "99",
    },
    {
      name: "Height",
      type: "BodyMeasurement",
      codeDisplay: "Body height",
      value: "",
      sign: "cm",
      added: true,
      categoryDisplay: "Vital Signs",
      unit: "cm",
      unitCode: "cm",
      lowerLimit: null,
      id: "body-height",
      upperLimit: null,
    },
    {
      name: "Weight",
      type: "BodyMeasurement",
      codeDisplay: "Body weight",
      value: "",
      sign: "kg",
      added: true,
      categoryDisplay: "Vital Signs",
      unit: "kg",
      unitCode: "kg",
      lowerLimit: null,
      id: "body-weight",
      upperLimit: null,
    },
  ]);
  const [bloodGroup, setBloodGroup] = useState(null);
  const [bloodGroupFirstTime, setBloodGroupFirstTime] = useState(null);
  const [otherExaminations, setOtherExaminations] = useState("");
  const hasVitalValue = vitals.some((item) => item.value !== "");
  const hasDentalData = dentalData.length > 0;
  const [ruleSuggestionToggle, setRuleSuggestionToggle] = useState(true);
  const [aiSuggestionToggle, setAiSuggestionToggle] = useState(true);
  const [chiefComplaintsLength, setChiefComplaintsLength] = useState(0);
  const [chiefComplaintsStringified, setChiefComplaintsStringified] =
    useState(0);
  const [abdmInterperabilityToggle, setAbdmInterperabilityToggle] =
    useState(true);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [summary, setSummary] = useState(null);
  const [prevSummary, setPrevSummary] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openPastRecordsModal, setOpenPastRecordsModal] = useState(false);
  const [summaryDrawerOpen, setSummaryDrawerOpen] = useState(false);
  const [timelineDrawerOpen, setTimelineDrawerOpen] = useState(false);
  const [selectedMedicalSection, setSelectedMedicalSection] =
    useState("ABDM Records");
  const [suggestions, setSuggestions] = useState(initialSuggestions);
  const [activeSection, setActiveSection] = useState(defaultActiveSectionKey);
  const [prevActiveSection, setPrevActiveSection] = useState(null);
  const [sectionsContent, setSectionsContent] = useState({
    "Chief Complaints": "",
    Examinations: "",
    Diagnosis: "",
    Medications: "",
    Procedures: "",
    "Tests/Investigations": "",
    "Medical Advice": "",
    Attachments: "",
    // ... other sections
  });
  const [listeningOn, setListeningOn] = useState(false);
  const [selectedSectionsData, setSelectedSectionsData] = useState({
    "Chief Complaints": [],
    Examinations: [],
    Diagnosis: [],
    "Adult Vaccination": [],
    Procedures: [],
    Medications: [],
    "Tests/Investigations": [],
    Referral: [],
    FollowUp: [],
    IPDAdmissionReferral: [],
    Attachments: [],
    InitialObservation: [],
    MedicalAdvice: {},
    // Advices: [],
  });
  const [referralError, setReferralError] = useState({});
  const [followUpError, setFollowUpError] = useState({});
  const [ipdReferralError, setIpdReferralError] = useState({});
  const [routeAutoData, setRouteAutoData] = useState([]);
  // const [pdfFooter, setPdfFooter] = useState(null);
  const [historySectionOpen, setHistorySectionOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [departments, setDepartments] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [showTelePanel, setShowTelePanel] = useState(false);
  const [teleCallStarted, setTeleCallStarted] = useState(false);
  const [teleCopied, setTeleCopied] = useState(false);
  const [openPatientSummaryModal, setOpenPatientSummaryModal] = useState(false);
  const [isCaseSheetOpen, setIsCaseSheetOpen] = useState(false);
  // const [openPatientSummaryModal, setOpenPatientSummaryModal] = useState(
  //   sessionStorage.getItem("isAiEnabled") !== undefined &&
  //     sessionStorage.getItem("isAiEnabled") !== null
  //     ? JSON.parse(sessionStorage.getItem("isAiEnabled"))
  //     : false
  // );
  const [openMicModal, setOpenMicModal] = useState(false);
  const [language, setLanguage] = useState("en");
  const [sectionToEdit, setSectionToEdit] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [recordingTime, setRecordingTime] = useState(0); // in seconds
  const [patientSummary, setPatientSummary] = useState({});
  // Sections are expanded by default; this holds the ones the doctor collapsed,
  // so sections a remote config enables after mount also start open.
  // "Transcription" is seeded so it keeps its existing closed-until-clicked default.
  const [collapsedOuter, setCollapsedOuter] = useState(["Transcription"]);
  const [floatingMenuOpen, setFloatingMenuOpen] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoadingSummary, setIsLoadingSummary] = useState(false);
  const [voiceTranscripton, setVoiceTransciption] = useState(false);
  const [limitMessage, setLimitMessage] = useState("");
  const [isSubmittingTextPrescription, setIsSubmittingTextPrescription] =
    useState(false);

  const getConsoleFeatureRuleContext = useCallback(
    () =>
      buildRuleContext({
        patient: state?.patientData,
        permissions: { isAiEnabled },
        appointment: { dateForAppointment: state?.dateForAppointment },
        doctor: state?.doctorData,
        stores: {
          selectedSectionsData,
          medicalBackground,
          vitals,
          dentalData,
          bloodGroup,
        },
      }),
    [
      state?.patientData,
      isAiEnabled,
      state?.dateForAppointment,
      state?.doctorData,
      selectedSectionsData,
      medicalBackground,
      vitals,
      dentalData,
      bloodGroup,
    ],
  );

  const isConsoleFeatureEnabled = useCallback(
    (featureId) =>
      isFeatureEnabled(
        consoleConfig,
        featureId,
        getConsoleFeatureRuleContext(),
      ),
    [consoleConfig, getConsoleFeatureRuleContext],
  );

  const RECORDING_LIMIT_MS = 241000; // 4 minutes is set as the recording limit per use + 1 sec for padding
  // const RECORDING_LIMIT_MS = 31000;
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const streamRef = useRef(null);
  const timerRef = useRef(null);
  const chunksRef = useRef([]);
  const recordingStartRef = useRef(null); // timestamp when recording/resume started
  const elapsedRef = useRef(0); // accumulated elapsed ms while recording (not paused)
  const limitTimeoutRef = useRef(null); // timeout id for auto-stop

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const REACT_APP_SENDER_EMAIL = process.env.REACT_APP_SENDER_EMAIL;
  useEffect(() => {
    setAbdmInterperabilityToggle(isAbdmEnabled);
  }, [isAbdmEnabled]);
  const toggleFloatingMenu = () => {
    setFloatingMenuOpen((prev) => !prev);
  };

  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const wellnessPdfRef = useRef();
  const prescriptionPdfRef = useRef();
  const PrescriptionPdfPdfRef = useRef();

  useEffect(() => {
    getAllDepartments();
    isAiEnabled && getPatientSummary();
  }, []);

  // --- Draft helpers: apply data, sync to IndexedDB, and call prescription_draft API ---

  /** Applies restored draft fields into React state (sections, history, vitals). */
  const applyConsultationDraftToScreen = (draftData) => {
    setSelectedSectionsData(
      draftData?.selectedSectionsData || EMPTY_SELECTED_SECTIONS_DATA,
    );
    setMedicalBackground(
      draftData?.medicalBackground ||
        buildMedicalBackgroundInitial(doctorConsoleConfig),
    );
    if (Array.isArray(draftData?.vitals)) {
      setVitals(draftData.vitals);
    }
  };

  /**
   * Keeps IndexedDB in sync for crash recovery and 30s autosave.
   * Stores doctorId + patientId + appointment_id (used on appointments list for Resume vs Start).
   * isDirty: true = local changes not yet saved via Save Draft; false = synced to server.
   */
  const persistDoctorConsoleDraftToIndexedDB = async ({
    data,
    isDirty = true,
  }) => {
    await upsertDraftRecord({
      key: DOCTOR_CONSOLE_DRAFT_KEY,
      doctorId: consoleDoctorId,
      patientId: currentPatientId,
      patientName: displayPatientNameFromParts(state?.patientData, ""),
      appointment_id: state?.appointmentId ?? null,
      updatedAt: new Date().toISOString(),
      isDirty,
      data,
    });
  };

  /** POST prescription_draft/ — explicit Save Draft or saving another patient's local draft. */
  const savePrescriptionDraftToServer = async (
    appointmentId,
    prescription_as_draft,
  ) =>
    axios.post(
      `${REACT_APP_BACKEND_ROUTE_URL}prescription_draft/`,
      {
        appointment_id: appointmentId,
        prescription_as_draft,
      },
      { headers },
    );

  /** DELETE prescription_draft/ — on Submit or when user declines restoring a server draft. */
  const deletePrescriptionDraftFromServer = async (appointmentId) =>
    axios.delete(`${REACT_APP_BACKEND_ROUTE_URL}prescription_draft/`, {
      headers,
      data: { appointment_id: appointmentId },
    });

  /** GET prescription_draft/?appointment_id= — used when no local IndexedDB draft exists. */
  const fetchPrescriptionDraftFromServer = async (appointmentId) =>
    axios.get(`${REACT_APP_BACKEND_ROUTE_URL}prescription_draft/`, {
      headers,
      params: { appointment_id: appointmentId },
    });

  /**
   * Restore UX for dirty IndexedDB drafts (isDirty !== false).
   * Returns "delete" if user confirms discard; otherwise restores.
   * persistToIndexedDBOnRestore: false when caller will refresh IndexedDB after local restore.
   */
  const promptRestoreConsultationDraft = async (
    draftData,
    { persistToIndexedDBOnRestore = true } = {},
  ) => {
    const shouldRestore = await showConfirmDialog(
      "A draft is available for this patient. Do you want to restore it?",
    );
    if (shouldRestore) {
      applyConsultationDraftToScreen(draftData);
      if (persistToIndexedDBOnRestore) {
        await persistDoctorConsoleDraftToIndexedDB({
          data: draftData,
          isDirty: false,
        });
      }
      toast.info("Draft restored.");
      return;
    }

    const confirmDelete = await showConfirmDialog(
      "If you don't restore this draft, it will be deleted. Continue?",
    );
    if (confirmDelete) {
      return "delete"; // Caller deletes from IndexedDB and/or server
    }
    // User chose not to delete — restore anyway (same behavior as before)
    applyConsultationDraftToScreen(draftData);
    if (persistToIndexedDBOnRestore) {
      await persistDoctorConsoleDraftToIndexedDB({
        data: draftData,
        isDirty: false,
      });
    }
    toast.info("Draft restored.");
  };

  /**
   * Opening a new patient while IndexedDB still holds the previous patient's draft.
   * isDirty false: already POSTed via Save Draft — clear local only, no dialog.
   * isDirty true: ask to POST previous draft, or clear local without saving.
   */
  const handleOtherPatientIndexedDbDraft = async (draftRecord) => {
    const {
      patientId: draftPatientId,
      patientName: draftPatientName,
      data,
    } = draftRecord;
    const draftAppointmentId = getDraftAppointmentId(draftRecord);
    // Treat missing isDirty (legacy records) as dirty
    const isDirty = draftRecord.isDirty !== false;

    if (!isDirty) {
      await clearDraftRecord(DOCTOR_CONSOLE_DRAFT_KEY);
      return;
    }

    const shouldSavePreviousDraft = await showConfirmDialog(
      `You have unsaved consultation data for a previous patient (${draftPatientName || draftPatientId}). Would you like to save it as a draft before continuing with this consultation?`,
    );

    if (shouldSavePreviousDraft) {
      if (!draftAppointmentId) {
        toast.error(
          "Unable to save the previous patient's draft because appointment information is missing.",
        );
        return;
      }
      try {
        const response = await savePrescriptionDraftToServer(
          draftAppointmentId,
          data,
        );
        if (response.data?.status === "Success") {
          await clearDraftRecord(DOCTOR_CONSOLE_DRAFT_KEY);
          toast.success("Previous patient's draft saved successfully.");
        } else {
          toast.error(
            response.data?.message ||
              "Failed to save the previous patient's draft.",
          );
        }
      } catch (error) {
        console.error(
          "Failed to save previous patient prescription draft:",
          error,
        );
        toast.error("Failed to save the previous patient's draft.");
      }
      return;
    }

    await clearDraftRecord(DOCTOR_CONSOLE_DRAFT_KEY);
  };

  /**
   * Fallback when IndexedDB has no draft for the current patient.
   * Server drafts apply silently (no restore popup); mirrored to IndexedDB with isDirty false.
   */
  const hydratePrescriptionDraftFromServer = async () => {
    const appointmentId = state?.appointmentId;
    if (!appointmentId) return;

    try {
      const response = await fetchPrescriptionDraftFromServer(appointmentId);
      if (
        response.data?.status !== "Success" ||
        !response.data?.data?.prescription_as_draft
      ) {
        return;
      }

      const draftData = response.data.data.prescription_as_draft;
      applyConsultationDraftToScreen(draftData);
      await persistDoctorConsoleDraftToIndexedDB({
        data: draftData,
        isDirty: false,
      });
      toast.info("Draft restored.");
    } catch (error) {
      console.error("Failed to fetch prescription draft from server:", error);
    }
  };

  /**
   * On consultation load: IndexedDB first, then server prescription_draft.
   * Order: other-patient local draft → same-patient local draft → GET server draft.
   */
  useEffect(() => {
    if (!currentPatientId) {
      hasHydratedDraftRef.current = true;
      return;
    }

    const hydrateDraft = async () => {
      try {
        // Drop another doctor's (or legacy) local draft before patient restore logic
        await clearDoctorConsoleDraftIfNotOwnedBy(consoleDoctorId);

        let draftRecord = await getDraftRecord(DOCTOR_CONSOLE_DRAFT_KEY);
        const draftPatientId = draftRecord?.patientId;
        const draftData = draftRecord?.data;

        // Step 1: IndexedDB belongs to a different patient
        if (
          draftData &&
          draftPatientId &&
          String(draftPatientId) !== String(currentPatientId)
        ) {
          await handleOtherPatientIndexedDbDraft(draftRecord);
          draftRecord = await getDraftRecord(DOCTOR_CONSOLE_DRAFT_KEY);
        }

        const samePatientDraftData = draftRecord?.data;
        const samePatientDraftPatientId = draftRecord?.patientId;

        // Step 2: IndexedDB draft for this patient — popup only when dirty;
        // isDirty false (synced via Save Draft / server GET) applies silently.
        if (
          samePatientDraftData &&
          samePatientDraftPatientId &&
          String(samePatientDraftPatientId) === String(currentPatientId) &&
          !isConsultationDraftContentEmpty(
            samePatientDraftData.selectedSectionsData,
            samePatientDraftData.medicalBackground,
            samePatientDraftData.vitals,
          )
        ) {
          const isDirty = draftRecord.isDirty !== false;

          if (!isDirty) {
            applyConsultationDraftToScreen(samePatientDraftData);
            await persistDoctorConsoleDraftToIndexedDB({
              data: samePatientDraftData,
              isDirty: false,
            });
            toast.info("Draft restored.");
            return;
          }

          const restoreResult = await promptRestoreConsultationDraft(
            samePatientDraftData,
            { persistToIndexedDBOnRestore: false },
          );
          if (restoreResult === "delete") {
            await clearDraftRecord(DOCTOR_CONSOLE_DRAFT_KEY);
            toast.info("Draft deleted.");
          } else {
            // Re-persist so 30s autosave / crash recovery continue after restore
            await persistDoctorConsoleDraftToIndexedDB({
              data: samePatientDraftData,
              isDirty: true,
            });
          }
          return;
        }

        // Step 3: No local draft — try backend
        await hydratePrescriptionDraftFromServer();
      } catch (error) {
        console.error("Failed to hydrate doctor console draft:", error);
      } finally {
        hasHydratedDraftRef.current = true;
      }
    };

    hydrateDraft();
  }, [currentPatientId, consoleDoctorId]);

  /** Every 30s: write consultation snapshot to IndexedDB for crash recovery (isDirty stays true until Save Draft). */
  useEffect(() => {
    if (!autosaveEnabled) return;
    if (!hasHydratedDraftRef.current || !currentPatientId) return;

    const intervalId = setInterval(() => {
      if (draftAutosaveDisabledAfterSubmitRef.current) return;
      if (
        isConsultationDraftContentEmpty(
          selectedSectionsData,
          medicalBackground,
          vitals,
        )
      ) {
        clearDraftRecord(DOCTOR_CONSOLE_DRAFT_KEY).catch((error) =>
          console.error("Failed to clear empty doctor console draft:", error),
        );
        return;
      }
      upsertDraftRecord({
        key: DOCTOR_CONSOLE_DRAFT_KEY,
        doctorId: consoleDoctorId,
        patientId: currentPatientId,
        patientName: displayPatientNameFromParts(state?.patientData, ""),
        appointment_id: state?.appointmentId ?? null,
        updatedAt: new Date().toISOString(),
        isDirty: true, // Local edits not yet POSTed via Save Draft
        data: buildConsultationDraftData(
          selectedSectionsData,
          medicalBackground,
          vitals,
        ),
      }).catch((error) =>
        console.error("Failed to auto save doctor console draft:", error),
      );
    }, autosaveIntervalMs);

    return () => clearInterval(intervalId);
  }, [
    autosaveEnabled,
    autosaveIntervalMs,
    consoleDoctorId,
    currentPatientId,
    selectedSectionsData,
    medicalBackground,
    vitals,
  ]);

  /**
   * After Save Draft (isDirty false), any consultation change should flip isDirty true
   * before the next interval — drives "save previous patient?" when switching patients.
   */
  useEffect(() => {
    if (!autosaveEnabled) return;
    if (!hasHydratedDraftRef.current || !currentPatientId) return;
    if (draftAutosaveDisabledAfterSubmitRef.current) return;
    if (
      isConsultationDraftContentEmpty(
        selectedSectionsData,
        medicalBackground,
        vitals,
      )
    ) {
      return;
    }

    const markDraftDirtyAfterServerSave = async () => {
      try {
        const record = await getDraftRecord(DOCTOR_CONSOLE_DRAFT_KEY);
        if (
          !record?.patientId ||
          String(record.patientId) !== String(currentPatientId) ||
          record.isDirty !== false
        ) {
          return;
        }
        await upsertDraftRecord({
          ...record,
          doctorId: consoleDoctorId,
          appointment_id: state?.appointmentId ?? getDraftAppointmentId(record),
          updatedAt: new Date().toISOString(),
          isDirty: true,
          data: buildConsultationDraftData(
            selectedSectionsData,
            medicalBackground,
            vitals,
          ),
        });
      } catch (error) {
        console.error("Failed to mark doctor console draft as dirty:", error);
      }
    };

    markDraftDirtyAfterServerSave();
  }, [
    autosaveEnabled,
    consoleDoctorId,
    currentPatientId,
    selectedSectionsData,
    medicalBackground,
    vitals,
    state?.patientData,
    state?.appointmentId,
  ]);

  const getAllDepartments = () => {
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`, {
        headers,
      })
      .then((res) => {
        console.log("Res Data", res);
        if (res.data.status != "Failed") {
          setDepartments(res.data.department_list);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getPatientSummary = () => {
    setIsLoadingSummary(true);
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}summarize_patient_records/`,
        {
          model_choice: 1,
          max_words: 300,
          patient_id: state?.patientData?.patient_id,
        },
        {
          headers,
        },
      )
      .then((res) => {
        if (res.data.status === "Success") {
          setPatientSummary(res.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoadingSummary(false);
      });
  };

  const isOuterExpanded = (sectionName) =>
    !collapsedOuter.includes(sectionName);

  const handleOuterAccordionChange = (sectionName) => (event, isExpanded) => {
    setCollapsedOuter((prev) => {
      if (isExpanded) return prev.filter((name) => name !== sectionName);
      return prev.includes(sectionName) ? prev : [...prev, sectionName];
    });
  };

  const clearDoctorConsoleDraft = async () => {
    try {
      await clearDraftRecord(DOCTOR_CONSOLE_DRAFT_KEY);
    } catch (error) {
      console.error("Failed to clear doctor console draft:", error);
    }
  };

  const deleteServerPrescriptionDraftAfterSubmit = () => {
    const appointmentId = state?.appointmentId;
    if (!appointmentId) return;
    deletePrescriptionDraftFromServer(appointmentId).catch((error) => {
      console.error(
        "Failed to delete server prescription draft on submit:",
        error,
      );
    });
  };

  /**
   * Save Draft button: POST prescription_as_draft, then set IndexedDB isDirty false
   * (keep local copy on same page for autosave / crash recovery).
   */
  const handleSavePrescriptionDraft = async () => {
    const appointmentId = state?.appointmentId;
    if (!appointmentId) {
      toast.error("Appointment information is missing.");
      return;
    }

    const prescription_as_draft = buildConsultationDraftData(
      selectedSectionsData,
      medicalBackground,
      vitals,
    );

    if (
      isConsultationDraftContentEmpty(
        selectedSectionsData,
        medicalBackground,
        vitals,
      )
    ) {
      toast.warn("There is no consultation data to save as a draft.");
      return;
    }

    setIsSavingPrescriptionDraft(true);
    try {
      const response = await savePrescriptionDraftToServer(
        appointmentId,
        prescription_as_draft,
      );
      if (response.data?.status === "Success") {
        toast.success("Draft saved successfully.");
        // Synced to server; local copy retained with isDirty false until user edits again
        await persistDoctorConsoleDraftToIndexedDB({
          data: prescription_as_draft,
          isDirty: false,
        });
      } else {
        toast.error(response.data?.message || "Failed to save draft.");
      }
    } catch (error) {
      console.error("Failed to save prescription draft:", error);
      toast.error("Failed to save draft. Please try again.");
    } finally {
      setIsSavingPrescriptionDraft(false);
    }
  };

  const handleOpenPatientSummaryModal = () => {
    setOpenPatientSummaryModal(true);
  };
  const handleClosePatientSummaryModal = () => {
    setOpenPatientSummaryModal(false);
  };
  const handleClosePastRecordsModal = () => {
    setOpenPastRecordsModal(false);
  };
  const handleOpenMicModal = () => {
    if (!isConsoleFeatureEnabled("voicePrescription")) return;
    setAudioBlob(null); // reset
    setOpenMicModal(true);
  };

  const handleCloseMicModal = () => {
    if (isRecording) {
      toast.error("Please stop recording before closing.");
      return;
    }
    setOpenMicModal(false);
    setRecordingTime(0);
    clearInterval(timerRef.current);
  };

  const handleGetTranscription = (voice_id) => {
    if (!isConsoleFeatureEnabled("transcription")) return;
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_voice_transcription/`,
        { voice_id: voice_id },
        {
          headers,
        },
      )
      .then((res) => {
        console.log("Res Data", res);
        if (res.data.status !== "Failed") {
          setVoiceTransciption(res.data.data.transcript);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const applyPrescriptionData = (data) => {
    const sanitizedData = sanitizeVoiceData(data);
    console.log("sanitizedData", sanitizedData);
    setSelectedSectionsData((prevData) => {
      const mergedData = { ...prevData };

      Object.keys(sanitizedData).forEach((section) => {
        let sectionData = sanitizedData[section];

        //Special handling for FollowUp
        if (section === "FollowUp" && Array.isArray(sectionData)) {
          sectionData = sectionData.map((item) => {
            if (
              !item.service_type?.trim() && // service_type is empty
              item.duration // duration is present
            ) {
              return {
                ...item,
                service_type: `Follow up after ${formatDurationTextForDisplay(
                  item.duration,
                )}`,
              };
            }
            return item;
          });
        }

        //Special handling for Referral
        if (section === "Referral" && Array.isArray(sectionData)) {
          sectionData = sectionData.map((item) => {
            if (
              !item.service_description?.trim() && // service_description is empty
              item?.doctor_details?.name // doctor name is present
            ) {
              return {
                ...item,
                service_description: `Referred to another doctor`,
                doctor_details: {
                  doctor_id: `9999-${item?.doctor_details?.name}`,
                  name: item?.doctor_details?.name,
                },
                service_category: item.service_category?.trim()
                  ? item.service_category?.trim()
                  : "Other/External",
              };
            }
            return item;
          });
        }

        //Merging Logic
        if (Array.isArray(sectionData)) {
          mergedData[section] = [...(prevData[section] || []), ...sectionData];
        } else {
          mergedData[section] = sectionData;
        }
      });

      return mergedData;
    });

    setDentalData((prevDentalData) => {
      var mergedData = { ...prevDentalData };
      const sectionData = sanitizedData["DentalData"];
      if (Array.isArray(sectionData)) {
        mergedData = [...(prevDentalData || []), ...sectionData];
      }

      return mergedData;
    });

    setVitals((prevVitals) =>
      prevVitals.map((vital) => {
        const updatedVital = sanitizedData["VitalSigns"]?.find(
          (item) => item.name?.toLowerCase() === vital.name?.toLowerCase(),
          // (item) => item.id === vital.id
        );
        return updatedVital ? { ...vital, ...updatedVital } : vital;
      }),
    );

    const historyFromResponse = data?.History || {};
    const sanitizedHistory = sanitizeHistoryFromVoiceData(historyFromResponse);

    setMedicalBackground((prevData) => {
      const mergedBackground = { ...prevData };

      Object.keys(sanitizedHistory).forEach((section) => {
        const newItems = sanitizedHistory[section]?.new || [];

        if (!mergedBackground[section]) {
          mergedBackground[section] = { prev: [], new: [] };
        }

        mergedBackground[section] = {
          ...mergedBackground[section],
          new: [...(mergedBackground[section].new || []), ...newItems],
        };
      });

      return mergedBackground;
    });
  };

  const handleSubmitRecording = async () => {
    if (!audioBlob) {
      toast.error("No recording available to send.");
      return;
    }

    const formData = new FormData();
    formData.append("language", language);
    formData.append("file", audioBlob, "voice-recording.webm");

    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}add_prescription/`,
        formData,
        { headers: headers },
      );
      // console.log("response-->", response);
      // console.log("response header desired-->", response.headers["x-voice-id"]);

      if (response.data.status == "Success") {
        const detail = response.data.data?.detail;
        const detailStatus = response.data.data?.status;
        if (detail || (detailStatus && detailStatus === "Failed")) {
          toast.error("Error decoding voice. Please try again later.");
        } else {
          applyPrescriptionData(response?.data?.data);

          if (isConsoleFeatureEnabled("transcription")) {
            handleGetTranscription(response.headers["x-voice-id"]);
          }
          toast.success("Recording submitted successfully!");
          setOpenMicModal(false);
        }
      } else {
        toast.error("Failed to submit recording.");
      }
    } catch (error) {
      console.error("Error submitting:", error);
      toast.error("Network error during submission.");
    }
  };

  const handleSubmitTextPrescription = async (text) => {
    const trimmedText = (text || "").trim();
    if (!trimmedText) {
      toast.error("Please enter the prescription text.");
      return;
    }

    setIsSubmittingTextPrescription(true);
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}add_prescription_text/`,
        { text: trimmedText, language: "en", model_choice: 1 },
        { headers: headers },
      );

      if (response.data.status == "Success") {
        const detail = response.data.data?.detail;
        const detailStatus = response.data.data?.status;
        if (detail || (detailStatus && detailStatus === "Failed")) {
          toast.error("Error processing text. Please try again later.");
        } else {
          applyPrescriptionData(response?.data?.data);
          toast.success("Prescription text submitted successfully!");
          setOpenMicModal(false);
        }
      } else {
        toast.error("Failed to submit prescription text.");
      }
    } catch (error) {
      console.error("Error submitting:", error);
      toast.error("Network error during submission.");
    } finally {
      setIsSubmittingTextPrescription(false);
    }
  };
  // Start recording: resets timing, asks for mic, starts MediaRecorder, and schedules auto-stop.
  const handleStartRecording = async () => {
    try {
      // If any previous timeout exists, clear it (safety).
      clearTimeout(limitTimeoutRef.current);

      // Reset accumulated elapsed time when starting fresh
      elapsedRef.current = 0;

      // Record the start timestamp (used to compute elapsed on pause)
      recordingStartRef.current = Date.now();

      // Clear any previous limit message shown in UI
      setLimitMessage("");

      // Request microphone access and keep the MediaStream
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;

      // Create a MediaRecorder for the stream
      const recorder = new MediaRecorder(stream);

      // reset collected audio chunks for this recording
      chunksRef.current = [];

      // ondataavailable collects the recorded Blob chunks
      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunksRef.current.push(e.data);
      };

      // when recorder stops, combine chunks to a Blob and set state
      recorder.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        setAudioBlob(blob);
        // cleanup, make sure any timeout is cleared
        clearTimeout(limitTimeoutRef.current);
      };

      // start the actual recording
      recorder.start();
      mediaRecorderRef.current = recorder;

      // UI state flags
      setIsRecording(true);
      setIsPaused(false);

      // schedule auto-stop for the full limit (since elapsedRef is zero right now)
      limitTimeoutRef.current = setTimeout(() => {
        // If recorder still active, stop it and stop the stream tracks
        if (
          mediaRecorderRef.current &&
          mediaRecorderRef.current.state !== "inactive"
        ) {
          mediaRecorderRef.current.stop();
          mediaRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
        }
        // Update UI states
        setIsRecording(false);
        setIsPaused(false);

        // Instead of toast, set an on-screen message
        setLimitMessage(
          "Maximum recording length per use (4 minutes) reached — recording stopped. You can submit multiple recordings per consultation.",
        );
      }, RECORDING_LIMIT_MS);
    } catch (err) {
      console.error("Error starting recording:", err);
      // optional: show error message to user
      setLimitMessage(
        "Unable to start recording. Please check microphone permissions.",
      );
    }
  };

  // Pause recording: accumulate elapsed ms and clear the auto-stop timeout.
  // This ensures paused time does not count toward the 4 minute limit.
  const handlePauseRecording = () => {
    if (mediaRecorderRef.current?.state === "recording") {
      // take the current time and add the time since recordingStartRef to elapsedRef
      const now = Date.now();
      elapsedRef.current += now - (recordingStartRef.current || now); // guard if null

      // Clear the scheduled auto-stop because we are paused now
      clearTimeout(limitTimeoutRef.current);

      // Pause MediaRecorder (browser behavior: recorder pauses, stream still active)
      mediaRecorderRef.current.pause();

      // update UI flag
      setIsPaused(true);
    }
  };

  // Resume recording: set new start timestamp, compute remaining time, and set a new timeout.
  // If remaining <= 0, stop immediately and inform the user.
  const handleResumeRecording = () => {
    if (mediaRecorderRef.current?.state === "paused") {
      // mark the moment we resumed so we can compute next elapsed duration
      const now = Date.now();
      recordingStartRef.current = now;

      // compute how much time remains from the 4 minute cap
      const remaining = RECORDING_LIMIT_MS - elapsedRef.current;

      // if remaining <= 0, limit already reached while paused (edge-case)
      if (remaining <= 0) {
        if (
          mediaRecorderRef.current &&
          mediaRecorderRef.current.state !== "inactive"
        ) {
          mediaRecorderRef.current.stop();
          mediaRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
        }
        setIsRecording(false);
        setIsPaused(false);
        setLimitMessage(
          "Maximum recording length per use (4 minutes) reached — recording stopped. You can submit multiple recordings per consultation.",
        );
        return;
      }

      // schedule a new timeout for the remaining time (use remaining ms)
      limitTimeoutRef.current = setTimeout(() => {
        if (
          mediaRecorderRef.current &&
          mediaRecorderRef.current.state !== "inactive"
        ) {
          mediaRecorderRef.current.stop();
          mediaRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
        }
        setIsRecording(false);
        setIsPaused(false);
        setLimitMessage(
          "Maximum recording length per use (4 minutes) reached — recording stopped. You can submit multiple recordings per consultation.",
        );
      }, remaining);

      // resume the MediaRecorder
      mediaRecorderRef.current.resume();
      setIsPaused(false);
    }
  };

  // Manual stop (user pressed Stop): stops the recorder and clears timing state.
  // Also cleans up the auto-stop timeout and resets elapsed tracking.
  const handleStopRecording = () => {
    if (mediaRecorderRef.current) {
      try {
        // stop recorder if active
        if (mediaRecorderRef.current.state !== "inactive") {
          mediaRecorderRef.current.stop();
        }
        // stop all tracks on the stream (releases microphone)
        if (mediaRecorderRef.current.stream) {
          mediaRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
        }
      } catch (e) {
        // ignore exceptions if already stopped
      }
    }

    // clear the scheduled auto-stop, reset timing refs
    clearTimeout(limitTimeoutRef.current);
    recordingStartRef.current = null;
    elapsedRef.current = 0;

    // clear limit UI message (optional)
    setLimitMessage("");

    setIsRecording(false);
    setIsPaused(false);
  };

  // const handleStartRecording = async () => {
  //   try {
  //     // reset any previous state
  //     clearTimeout(limitTimeoutRef.current);
  //     elapsedRef.current = 0;
  //     recordingStartRef.current = Date.now();

  //     const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  //     streamRef.current = stream;
  //     const recorder = new MediaRecorder(stream);

  //     chunksRef.current = [];

  //     recorder.ondataavailable = (e) => {
  //       if (e.data.size > 0) chunksRef.current.push(e.data);
  //     };

  //     recorder.onstop = () => {
  //       const blob = new Blob(chunksRef.current, { type: "audio/webm" });
  //       setAudioBlob(blob);
  //       // cleanup
  //       clearTimeout(limitTimeoutRef.current);
  //     };

  //     recorder.start();
  //     mediaRecorderRef.current = recorder;
  //     setIsRecording(true);
  //     setIsPaused(false);

  //     // start auto-stop timeout for full limit
  //     limitTimeoutRef.current = setTimeout(() => {
  //       // Auto stop when limit reached
  //       if (
  //         mediaRecorderRef.current &&
  //         mediaRecorderRef.current.state !== "inactive"
  //       ) {
  //         mediaRecorderRef.current.stop();
  //         mediaRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
  //       }
  //       setIsRecording(false);
  //       setIsPaused(false);
  //       toast.info(
  //         "Maximum recording length (4 minutes) reached — recording stopped."
  //       );
  //     }, RECORDING_LIMIT_MS);
  //   } catch (err) {
  //     console.error("Error starting recording:", err);
  //   }
  // };

  // const handlePauseRecording = () => {
  //   if (mediaRecorderRef.current?.state === "recording") {
  //     // accumulate elapsed time up to pause moment
  //     const now = Date.now();
  //     elapsedRef.current += now - (recordingStartRef.current || now);
  //     // clear running timeout
  //     clearTimeout(limitTimeoutRef.current);

  //     mediaRecorderRef.current.pause();
  //     setIsPaused(true);
  //   }
  // };

  // const handleResumeRecording = () => {
  //   if (mediaRecorderRef.current?.state === "paused") {
  //     const now = Date.now();
  //     recordingStartRef.current = now;

  //     // compute remaining time
  //     const remaining = RECORDING_LIMIT_MS - elapsedRef.current;
  //     if (remaining <= 0) {
  //       // already exceeded - stop immediately and inform user
  //       if (
  //         mediaRecorderRef.current &&
  //         mediaRecorderRef.current.state !== "inactive"
  //       ) {
  //         mediaRecorderRef.current.stop();
  //         mediaRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
  //       }
  //       setIsRecording(false);
  //       setIsPaused(false);
  //       toast.info(
  //         "Maximum recording length (4 minutes) reached — recording stopped."
  //       );
  //       return;
  //     }

  //     // set a new timeout for remaining time
  //     limitTimeoutRef.current = setTimeout(() => {
  //       if (
  //         mediaRecorderRef.current &&
  //         mediaRecorderRef.current.state !== "inactive"
  //       ) {
  //         mediaRecorderRef.current.stop();
  //         mediaRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
  //       }
  //       setIsRecording(false);
  //       setIsPaused(false);
  //       toast.info(
  //         "Maximum recording length (4 minutes) reached — recording stopped."
  //       );
  //     }, remaining);

  //     mediaRecorderRef.current.resume();
  //     setIsPaused(false);
  //   }
  // };

  // const handleStopRecording = () => {
  //   if (mediaRecorderRef.current) {
  //     // stop recorder and tracks
  //     try {
  //       if (mediaRecorderRef.current.state !== "inactive") {
  //         mediaRecorderRef.current.stop();
  //       }
  //       if (mediaRecorderRef.current.stream) {
  //         mediaRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
  //       }
  //     } catch (e) {
  //       // ignore if already stopped
  //     }
  //   }

  //   // clear timers and reset duration refs
  //   clearTimeout(limitTimeoutRef.current);
  //   recordingStartRef.current = null;
  //   elapsedRef.current = 0;
  //   setIsRecording(false);
  //   setIsPaused(false);
  // };

  const handleSubmitRecordingForEdit = async (source) => {
    if (source?.edit === "group" && !audioBlob) {
      toast.error("No recording available to send.");
      return;
    } else if (source?.edit === "individual" && !source?.audioBlob) {
      toast.error("No recording available to send.");
      return;
    }

    var json_file = {
      ...selectedSectionsData,
      VitalSigns: vitals,
      History: medicalBackground,
    };

    const formData = new FormData();
    formData.append("input_type", "voice");
    formData.append("language", language);
    formData.append(
      "sections",
      source?.edit === "group" ? sectionToEdit.join(",") : source?.section,
    );
    formData.append(
      "file",
      source?.edit === "group" ? audioBlob : source?.audioBlob,
      "voice-recording.webm",
    );
    // formData.append("json_file", json_file);
    formData.append(
      "json_file",
      new Blob([JSON.stringify(json_file)], { type: "application/json" }),
      "data.json",
    );

    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}update_prescription/`,
        formData,
        { headers: headers },
      );

      if (response.data.status === "Success") {
        const detail = response.data.data?.detail;
        const detailStatus = response.data.data?.status;

        if (detail || (detailStatus && detailStatus === "Failed")) {
          toast.error("Error decoding voice. Please try again later.");
          return;
        }

        // Using edited_section
        const editedSection = response.data.data?.edited_section || {};

        // Sanitize the edited section before merging
        const sanitizedData = {};
        Object.keys(editedSection).forEach((section) => {
          if (section !== "History") {
            sanitizedData[section] = sanitizeVoiceData({
              [section]: editedSection[section],
            })[section];
          }
        });

        console.log("sanitizedData", sanitizedData);

        // Merge only edited sections into selectedSectionsData
        setSelectedSectionsData((prevData) => {
          const mergedData = { ...prevData };

          Object.keys(sanitizedData).forEach((section) => {
            let sectionData = sanitizedData[section];

            //Special handling for FollowUp
            if (section === "FollowUp" && Array.isArray(sectionData)) {
              sectionData = sectionData.map((item) => {
                if (
                  !item.service_type?.trim() && // service_type is empty
                  item.duration // duration is present
                ) {
                  return {
                    ...item,
                    service_type: `Follow up after ${formatDurationTextForDisplay(
                      item.duration,
                    )}`,
                  };
                }
                return item;
              });
            }
            //Special handling for Referral
            if (section === "Referral" && Array.isArray(sectionData)) {
              sectionData = sectionData.map((item) => {
                if (
                  !item.service_description?.trim() && // service_description is empty
                  item?.doctor_details?.name // doctor name is present
                ) {
                  return {
                    ...item,
                    service_description: `Referred to another doctor`,
                    doctor_details: {
                      doctor_id: `9999-${item?.doctor_details?.name}`,
                      name: item?.doctor_details?.name,
                    },
                    service_category: item.service_category?.trim()
                      ? item.service_category?.trim()
                      : "Other/External",
                  };
                }
                return item;
              });
            }

            if (Array.isArray(sectionData)) {
              // Replace with edited section data
              mergedData[section] = sectionData;
            } else if (sectionData) {
              mergedData[section] = sectionData;
            }
          });

          return mergedData;
        });

        // Update vitals only if present in edited section
        if (sanitizedData["VitalSigns"]) {
          setVitals((prevVitals) =>
            prevVitals.map((vital) => {
              const updatedVital = sanitizedData["VitalSigns"].find(
                (item) =>
                  item.name?.toLowerCase() === vital.name?.toLowerCase(),
              );
              return updatedVital ? { ...vital, ...updatedVital } : vital;
            }),
          );
        }

        // Update medical background only if history present in edited section
        if (editedSection.History) {
          const sanitizedHistory = sanitizeHistoryFromVoiceData(
            editedSection.History,
          );

          setMedicalBackground((prevData) => {
            const mergedBackground = { ...prevData };

            Object.keys(sanitizedHistory).forEach((section) => {
              const newItems = sanitizedHistory[section]?.new || [];

              if (!mergedBackground[section]) {
                mergedBackground[section] = { prev: [], new: [] };
              }

              mergedBackground[section] = {
                ...mergedBackground[section],
                new: [
                  // ...(mergedBackground[section].new || []),
                  ...newItems,
                ],
              };
            });

            return mergedBackground;
          });
        }

        toast.success("Section updated successfully!");
        setSectionToEdit([]);
        setAudioBlob(null);
        setOpenMicModal(false);
      } else {
        toast.error("Failed to submit recording.");
      }
    } catch (error) {
      console.error("Error submitting:", error);
      toast.error("Network error during submission.");
    }
  };

  const sanitizeVoiceData = (data) => {
    // Removes HTML tags and trims spaces from any string.
    const sanitizeText = (str) =>
      typeof str === "string" ? str.replace(/<[^>]*>?/gm, "").trim() : "";

    // Returns true if a value is a non-empty string.
    const isNonEmptyString = (val) =>
      typeof val === "string" && val.trim() !== "";

    // Preserve complete duration text (e.g. "10 days", "2 weeks")
    const normalizeDuration = (duration) => {
      if (duration === null || duration === undefined) return "";

      if (typeof duration === "number") {
        return isNaN(duration) ? "" : String(duration);
      }

      if (typeof duration === "string") {
        return sanitizeText(duration);
      }

      return "";
    };

    // Helper to clean each section
    const cleanSection = (section, requiredKey = null, options = {}) => {
      if (!Array.isArray(section)) return [];

      return section
        .filter((item) => item && typeof item === "object")
        .map((item) => {
          const sanitizedItem = {};

          for (let key in item) {
            const val = item[key];

            if (key === "duration") {
              sanitizedItem[key] = normalizeDuration(val);
            } else if (Array.isArray(val)) {
              // Sanitize each item in the array if needed
              sanitizedItem[key] = val.map((v) =>
                typeof v === "object" && v !== null
                  ? Object.fromEntries(
                      Object.entries(v).map(([k, vv]) => [
                        k,
                        typeof vv === "string" ? sanitizeText(vv) : (vv ?? ""),
                      ]),
                    )
                  : typeof v === "string"
                    ? sanitizeText(v)
                    : v,
              );
            } else if (typeof val === "object" && val !== null) {
              const nestedSanitized = {};
              for (let nestedKey in val) {
                const nestedVal = val[nestedKey];
                nestedSanitized[nestedKey] =
                  typeof nestedVal === "string"
                    ? sanitizeText(nestedVal)
                    : (nestedVal ?? "");
              }
              sanitizedItem[key] = nestedSanitized;
            } else {
              sanitizedItem[key] =
                typeof val === "string" ? sanitizeText(val) : (val ?? "");
            }
          }

          // Mark all as coming from voice
          sanitizedItem.source = "voice";

          return sanitizedItem;
        })
        .filter((item) => {
          const hasContent = Object.values(item).some((val) => val !== "");

          const hasRequiredKey = requiredKey
            ? isNonEmptyString(item[requiredKey])
            : true;

          // Special condition for Referral
          if (options.skipIfDoctorNameEmpty) {
            const doctorName = item?.doctor_details?.name;
            if (!isNonEmptyString(doctorName)) return false;
          }

          return hasContent && hasRequiredKey;
        });
    };

    return {
      "Chief Complaints": cleanSection(data["Chief Complaints"], "condition"),
      Examinations: cleanSection(data["Examinations"]),
      Diagnosis: cleanSection(data["Diagnosis"], "term"),
      Procedures: cleanSection(data["Procedures"], "term"),
      Medications: cleanSection(data["Medications"], "term"),
      "Tests/Investigations": cleanSection(
        data["Tests/Investigations"],
        "term",
      ),
      Referral: cleanSection(data["Referral"], null, {
        skipIfDoctorNameEmpty: true,
      }),
      FollowUp: cleanSection(data["FollowUp"], "duration"),
      Attachments: cleanSection(data["Attachments"]),
      VitalSigns: cleanSection(data["VitalSigns"], "name"),
      DentalData: cleanSection(data["DentalData"], "id"),
      MedicalAdvice:
        typeof data["MedicalAdvice"] === "object" &&
        data["MedicalAdvice"] !== null &&
        "advice" in data["MedicalAdvice"] &&
        data["MedicalAdvice"].advice !== ""
          ? data["MedicalAdvice"]
          : {},
    };
  };

  const sanitizeHistoryFromVoiceData = (historyData) => {
    const sanitizeText = (str) =>
      typeof str === "string" ? str.replace(/<[^>]*>?/gm, "").trim() : "";

    const normalizeDuration = (duration) => {
      if (duration === null || duration === undefined) return "";

      if (typeof duration === "number") {
        return isNaN(duration) ? "" : String(duration);
      }

      if (typeof duration === "string") {
        return sanitizeText(duration);
      }

      return "";
    };

    const filterAndSanitize = (items, section) => {
      if (!Array.isArray(items)) return [];

      return (
        items
          // .map((item) => {
          //   const sanitized = {};
          //   for (let key in item) {
          //     const val = item[key];
          //     sanitized[key] =
          //       typeof val === "string" ? sanitizeText(val) : val ?? "";
          //   }
          //   return sanitized;
          // })
          .map((item) => {
            const sanitized = {};
            for (let key in item) {
              const val = item[key];

              // Apply numeric sanitization if the key is duration-like
              if (
                (key === "duration" ||
                  key === "abatement_duration" ||
                  key === "onset_duration") &&
                val !== null &&
                val !== undefined
              ) {
                sanitized[key] = normalizeDuration(val);
              } else {
                sanitized[key] =
                  typeof val === "string" ? sanitizeText(val) : (val ?? "");
              }
            }
            return sanitized;
          })
          .filter((item) => {
            switch (section) {
              case "History of Past Illness":
              case "History of Present Illness":
              case "Family History":
                return item.condition?.trim() !== "";
              case "Drug History":
                return item.drug_name?.trim() !== "";
              case "Allergies":
                return (
                  item.allergy_description?.trim() !== "" ||
                  item.allergy_type?.trim() !== ""
                );
              case "Addiction History":
                return (
                  item.addiction_description?.trim() !== "" ||
                  item.addiction_type?.trim() !== ""
                );
              case "Menstrual History":
                return item.description?.trim() !== "";
              case "Surgeries":
                return item.procedure?.trim() !== "";
              default:
                return true;
            }
          })
          .map((item) => ({
            ...item,
            source: "voice",
          }))
      );
    };

    const sanitizedHistory = {};

    Object.keys(historyData || {}).forEach((section) => {
      const newItems = filterAndSanitize(historyData[section]?.new, section);
      sanitizedHistory[section] = {
        prev: [],
        new: newItems,
      };
    });

    return sanitizedHistory;
  };

  const handleStartRecordingForIndividualSection = async () => {
    console.log("start recording");
    try {
      // Prevent duplicate recording
      if (isRecording) {
        toast.warning("Recording is already in progress.");
        return;
      }

      // Request microphone access
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      if (!stream) throw new Error("Unable to access microphone stream");

      streamRef.current = stream;

      // Initialize MediaRecorder
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event?.data && event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      // Added onstop handler (to generate blob & stop tracks)
      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: "audio/webm",
        });
        setAudioBlob(audioBlob);
        stream.getTracks().forEach((track) => track.stop());
      };

      // Start recording
      mediaRecorder.start();
      setIsRecording(true);
      setRecordingTime(0);

      // Timer for recording duration
      timerRef.current = setInterval(() => {
        setRecordingTime((prev) => prev + 1);
      }, 1000);
    } catch (err) {
      console.error("Microphone access denied or error: ", err);
      toast.error("Microphone access is required to record.");
    }
  };

  const handleStopRecordingForIndividualSection = async (sectionName) => {
    try {
      if (!isRecording) {
        toast.warning("No active recording to stop.");
        return;
      }

      if (mediaRecorderRef.current) {
        mediaRecorderRef.current.onstop = async () => {
          try {
            if (!audioChunksRef.current.length) {
              throw new Error("No audio data captured");
            }

            const audioBlob = new Blob(audioChunksRef.current, {
              type: "audio/webm",
            });
            setAudioBlob(audioBlob);

            // Stop all mic tracks
            streamRef.current?.getTracks().forEach((track) => track.stop());

            // Call submit handler after stop
            await handleSubmitRecordingForEdit({
              edit: "individual",
              section: sectionName,
              audioBlob: audioBlob,
            });
          } catch (err) {
            console.error("Error processing recording: ", err);
            toast.error("Failed to process the recording. Please try again.");
          }
        };

        mediaRecorderRef.current.stop(); // triggers onstop
        setIsRecording(false);
        clearInterval(timerRef.current);
      } else {
        throw new Error("No active media recorder found");
      }
    } catch (err) {
      console.error("Error stopping recording: ", err);
      toast.error("Failed to stop recording properly.");
    }
  };

  const memoizedDoctorData = useMemo(
    () => state?.doctorData,
    [JSON.stringify(state?.doctorData)],
  );

  const pdfFooter = useMemo(
    () => <PdfFooter doctorData={memoizedDoctorData} />,
    [memoizedDoctorData],
  );

  const handleClickPrint = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleCompleteAppointment = async () => {
    var data = {
      appointment_id: state?.appointmentId,
      status: "COMPLETED",
    };
    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}update_appointment/`, data, {
        headers: headers,
      })
      .then((res) => {
        if (res?.data?.status == "Success") {
          history.push("/doctor/appointments");
        } else {
          toast.error("Some error occurred. Please try again later.");
        }
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };

  console.log("doctor on console", state?.doctorData);
  useEffect(() => {
    console.log("doctor data is changing");
  }, [state?.doctorData]);
  useEffect(() => {
    console.log("Parent rendering");
  }, []);

  useEffect(async () => {
    try {
      const data = await axios.get(
        `${REACT_APP_BACKEND_ROUTE_URL}get_all_routes_of_administration/`,
        { headers: headers },
      );
      if (data.data && data.data.data) {
        const filteredData = data.data.data.map((d) => {
          return {
            label: d.route,
            id: d.snomed_code,
          };
        });
        setRouteAutoData(filteredData);
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  }, []);

  useEffect(async () => {
    // const today = new Date();
    const formattedDate = state?.dateForAppointment
      ?.toISOString()
      .split("T")[0];
    console.log(
      "Appointment Id from Doctor Console Page",
      state?.appointmentId,
    );
    const requestBody = {
      patient_id: state?.patientData.patient_id,
      visit_date: formattedDate,
      appointment_id: state?.appointmentId,
    };
    //fetching wellness record idf present for a patient than is taken by lab person
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_wellness_records/`,
        requestBody,
        { headers: headers },
      );
      if (response) {
        console.log("Vitals Data", response);
        if (
          response.data.message !==
          "Failed to fetch data. Please try again after sometime !!"
        ) {
          // Merge API response into existing default vitals so that all
          // fields are still rendered (and editable) even when the API
          // returns only a subset of vitals. Match by id first, then by name.
          const responseVitals = Array.isArray(response.data?.data)
            ? response.data.data
            : [];
          setVitals((prevVitals) =>
            prevVitals.map((vital) => {
              const matched = responseVitals.find(
                (r) =>
                  (r.id && vital.id && r.id === vital.id) ||
                  (r.name && vital.name && r.name === vital.name),
              );
              return matched
                ? {
                    ...vital,
                    value:
                      matched.value !== undefined && matched.value !== null
                        ? matched.value
                        : "",
                  }
                : vital;
            }),
          );
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }

    //patient static data fetch
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_patient_static_data/`,
        {
          patient_id: state?.patientData.patient_id,
          hip_id: facility_id,
        },
        { headers: headers },
      );
      if (response) {
        console.log("Patient Static Data", response);
        if (
          response.data.status === "Success" &&
          response.data.patient_static_data.blood_group !== null
        ) {
          setBloodGroupFirstTime(response.data.patient_static_data.blood_group);
          setBloodGroup(response.data.patient_static_data.blood_group);
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  }, []);

  useEffect(async () => {
    const requestBodyForFethingDoctorDepartment = {
      department: state?.doctorData.department,
    };
    //fetching wellness record idf present for a patient than is taken by lab person
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_chief_complaints_by_department/`,
        requestBodyForFethingDoctorDepartment,
        { headers: headers },
      );
      if (response) {
        const updatedSuggestions = { ...suggestions };
        updatedSuggestions["Chief Complaints"]["aiDriven"] =
          response.data.chief_complaints_list.map((comp) => ({
            name: comp,
            activate: false,
            removed: false,
            status: "active",
          }));
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  }, []);

  const handleGetPatientHistoryData = async () => {
    //Getting Patient hsitory
    try {
      const patientId = state?.patientData.patient_id;
      const historyPromise = axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_patient_history/`,
        { patient_id: patientId },
        { headers: headers },
      );
      const diabeticProfilePromise = axios.get(
        `${REACT_APP_BACKEND_ROUTE_URL}create_patient_diabetic_profile/?patient_id=${encodeURIComponent(patientId)}`,
        { headers: headers },
      );

      const [response, profileResponse] = await Promise.allSettled([
        historyPromise,
        diabeticProfilePromise,
      ]);

      if (response.status === "fulfilled" && response.value) {
        if (response.value.data.status === "Success") {
          console.log("Get History Response", response.value.data);
          const histories = response.value.data.histories || [];
          // console.log("Get History Success", finalFamilyHistory);
          let finalFamilyHistory = [],
            finalAllergyHistory = [],
            finalAddictionHistory = [],
            finalDrugHistory = [],
            finalMenstrualHistory = [],
            finalMedicalHistory = [],
            finalSurgicalHistory = [],
            finalImmunizationHistory = [];
          histories.forEach((entry) => {
            if (entry.medical_history) {
              finalMedicalHistory = finalMedicalHistory.concat(
                entry.medical_history,
              );
            }
            if (entry.surgical_history) {
              finalSurgicalHistory = finalSurgicalHistory.concat(
                entry.surgical_history,
              );
            }
            if (entry.family_history) {
              finalFamilyHistory = finalFamilyHistory.concat(
                entry.family_history,
              );
            }
            if (entry.allergy_history) {
              finalAllergyHistory = finalAllergyHistory.concat(
                entry.allergy_history,
              );
            }
            if (entry.addiction_history) {
              finalAddictionHistory = finalAddictionHistory.concat(
                entry.addiction_history,
              );
            }
            if (entry.drug_history) {
              finalDrugHistory = finalDrugHistory.concat(entry.drug_history);
            }
            if (entry.menstrual_history) {
              finalMenstrualHistory = finalMenstrualHistory.concat(
                entry.menstrual_history,
              );
            }
            if (entry.immunization_history) {
              finalImmunizationHistory = finalImmunizationHistory.concat(
                entry.immunization_history,
              );
            }
          });

          let isPrev =
            finalFamilyHistory.length > 0 ||
            finalAllergyHistory.length > 0 ||
            finalAddictionHistory.length > 0 ||
            finalDrugHistory.length > 0 ||
            finalMenstrualHistory.length > 0 ||
            finalMedicalHistory.length > 0 ||
            finalSurgicalHistory.length > 0 ||
            finalImmunizationHistory.length > 0;

          // Parse diabetic profile data
          let diabeticHistory = {};
          if (profileResponse.status === "fulfilled" && profileResponse.value) {
            const pd = profileResponse.value.data;
            diabeticHistory =
              (Array.isArray(pd?.data)
                ? pd.data[0]
                : Array.isArray(pd?.case_sheet)
                  ? pd.case_sheet[0]
                  : pd) || {};

            // Auto populate chief complaints from case sheet (JSONB array or legacy JSON string)
            if (diabeticHistory.chief_complaints != null) {
              let parsedCC = [];
              if (Array.isArray(diabeticHistory.chief_complaints)) {
                parsedCC = diabeticHistory.chief_complaints;
              } else if (typeof diabeticHistory.chief_complaints === "string") {
                try {
                  const fromString = JSON.parse(
                    diabeticHistory.chief_complaints,
                  );
                  parsedCC = Array.isArray(fromString) ? fromString : [];
                } catch (e) {
                  console.error(
                    "Failed to parse chief complaints from diabetic profile",
                    e,
                  );
                }
              }
              if (parsedCC.length > 0) {
                setSelectedSectionsData((prev) => ({
                  ...prev,
                  "Chief Complaints": parsedCC,
                }));
              }
            }
          }
          const getDiabeticField = (field) =>
            diabeticHistory[field] && Array.isArray(diabeticHistory[field])
              ? diabeticHistory[field]
              : [];

          const hasDiabetic =
            getDiabeticField("family_history").length > 0 ||
            getDiabeticField("allergies").length > 0 ||
            getDiabeticField("addiction_history").length > 0 ||
            getDiabeticField("drug_history").length > 0 ||
            getDiabeticField("menstrual_history").length > 0 ||
            getDiabeticField("medical_history").length > 0 ||
            getDiabeticField("surgeries_history").length > 0 ||
            getDiabeticField("vaccination_history").length > 0;

          // Update state if we have either kind of history
          console.log("hasDiabetic", hasDiabetic, "isPrev", isPrev);
          if (isPrev || hasDiabetic) {
            setMedicalBackground((prevState) => ({
              ...prevState,
              "Family History": {
                prev: finalFamilyHistory,
                new: getDiabeticField("family_history"),
              },
              Allergies: {
                prev: finalAllergyHistory,
                new: getDiabeticField("allergies"),
              },
              "Addiction History": {
                prev: finalAddictionHistory,
                new: getDiabeticField("addiction_history"),
              },
              "Drug History": {
                prev: finalDrugHistory,
                new: getDiabeticField("drug_history"),
              },
              "Menstrual History": {
                prev: finalMenstrualHistory,
                new: getDiabeticField("menstrual_history"),
              },
              "History of Past Illness": {
                prev: finalMedicalHistory,
                new: getDiabeticField("medical_history"),
              },
              "History of Present Illness": {
                prev: [],
                new: getDiabeticField("history_of_present_illness"),
              },
              Surgeries: {
                prev: finalSurgicalHistory,
                new: getDiabeticField("surgeries_history"),
              },
              "Adult Vaccination": {
                prev: finalImmunizationHistory,
                new: getDiabeticField("vaccination_history"),
              },
            }));
          }
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  useEffect(async () => {
    //Getting the history data at the first render
    handleGetPatientHistoryData();
  }, []);

  // console.log("Page no", pageNo);
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  console.log("Sections Content ", sectionsContent);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts or updates
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    //to check if the prev active section is chief complaints or not if yes then extracting no of lis inside the content of chief complaint and then checking if the length of that is equal to the state variable 'chiefComplaintsLength' if not then update that and on update of that we are generating our logic for ai and rule driven suggestions
    let chiefComplaints;

    if (aiSuggestionToggle || ruleSuggestionToggle) {
      chiefComplaints = selectedSectionsData["Chief Complaints"];
      if (chiefComplaints.length !== chiefComplaintsLength) {
        setChiefComplaintsLength(chiefComplaints.length);
      }
      let chiefComplaintsDeps = chiefComplaints
        .map((d) => {
          const complaintDuration = d.duration;
          return `${d.condition}|${complaintDuration}|${d.clinical_status_description}|${d.clinical_note}`;
        })
        .join(";");

      setChiefComplaintsStringified(chiefComplaintsDeps);
    }
  }, [prevActiveSection]);

  useEffect(() => {
    const chiefComplaints = selectedSectionsData["Chief Complaints"].map(
      (d) => d.condition,
    );

    const complaintsString = selectedSectionsData["Chief Complaints"]
      .map((item) => {
        let sentence = item.condition;
        const complaintDuration = item.duration;

        if (complaintDuration) {
          sentence += ` for ${complaintDuration}`;
        }

        if (
          item.clinical_status_description &&
          item.clinical_status_description !== "Unknown"
        ) {
          sentence += `, status ${item.clinical_status_description}`;
        }

        if (item.clinical_note) {
          sentence += `. Additional note: ${item.clinical_note}`;
        }

        return sentence;
      })
      .join("; ");

    const updateSuggestions = (newData, type) => {
      const updated = { ...suggestions };

      if (type === "aiDriven" || type === "ruleDriven") {
        updated["Tests/Investigations"][type] = [];
        updated["Procedures"][type] = [];
        updated["Diagnosis"][type] = [];
        updated["Medications"][type] = [];
      }

      newData.forEach((record) => {
        const isItemAlreadyPresent = (section, item) =>
          updated[section][type].some(
            (existingItem) => existingItem.name === (item.title || item),
          );

        // Shared helper for pushing items
        const pushItems = (section, items) => {
          items.forEach((itm) => {
            if (!isItemAlreadyPresent(section, itm)) {
              updated[section][type].push({
                name: type === "aiDriven" ? itm?.title : itm,
                activate: false,
                removed: false,
                reason: type === "aiDriven" ? itm?.reason : undefined,
              });
            }
          });
        };

        if (record["Tests"]) {
          const tests = Array.isArray(record["Tests"])
            ? record["Tests"]
            : record["Tests"].split(", ");
          pushItems("Tests/Investigations", tests);
          pushItems("Procedures", tests);
        }

        if (record["Diagnosis"]) {
          const diagnoses = Array.isArray(record["Diagnosis"])
            ? record["Diagnosis"]
            : record["Diagnosis"].split(", ");
          pushItems("Diagnosis", diagnoses);
        }

        if (record["Procedures"]) {
          const procedures = Array.isArray(record["Procedures"])
            ? record["Procedures"]
            : record["Procedures"].split(", ");
          pushItems("Procedures", procedures);
        }

        if (record["Medications"]) {
          const medications = Array.isArray(record["Medications"])
            ? record["Medications"]
            : record["Medications"].split(", ");
          pushItems("Medications", medications);
        }
      });

      setSuggestions(updated);
    };

    // Rule-based first
    if (
      prevActiveSection === "Chief Complaints" &&
      ruleSuggestionToggle &&
      chiefComplaints.length !== 0
    ) {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_rule_driven_suggestion/`,
          { chief_complaints: chiefComplaints },
          { headers },
        )
        .then((res) => {
          updateSuggestions(res.data.suggestions, "ruleDriven");

          // If AI toggle is also on then fetch AI but remove duplicates
          if (aiSuggestionToggle && isAiEnabled) {
            axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}diagnose/`,
                {
                  problem_description: complaintsString,
                  patient_age: state?.patientData.age,
                  patient_gender: state?.patientData.gender,
                },
                { headers },
              )
              .then((res2) => {
                // Remove AI items if they match rule-driven ones
                const removeDuplicates = (aiItems, ruleItems) =>
                  aiItems.filter(
                    (ai) =>
                      !ruleItems.some(
                        (rule) =>
                          (ai.title || ai).toLowerCase() ===
                          (rule.name || rule).toLowerCase(),
                      ),
                  );
                if (res2.data.status === "Success") {
                  const aiData = {
                    Tests: removeDuplicates(
                      res2.data.data.Tests || [],
                      suggestions["Tests/Investigations"].ruleDriven,
                    ),
                    Diagnosis: removeDuplicates(
                      res2.data.data.Diagnosis || [],
                      suggestions["Diagnosis"].ruleDriven,
                    ),
                    Procedures: [],
                    Medications: [],
                  };

                  updateSuggestions([aiData], "aiDriven");
                } else {
                  console.log(res2?.data?.status, res2?.data?.message);
                }
              })
              .catch((err) => console.error(err));
          }
        })
        .catch((err) => console.error(err));
    }
  }, [
    chiefComplaintsLength,

    chiefComplaintsStringified,
    aiSuggestionToggle,
    ruleSuggestionToggle,
    isAiEnabled,
    state?.patientData.age,
    state?.patientData.gender,
  ]);

  console.log("Vitals", vitals);

  const handleVoiceCommand = (command) => {
    switch (command.toLowerCase()) {
      case "insert line":
        if (prevSummary && summary) {
          setPrevSummary(summary);
          const currentContent = summary;
          const updatedContent = currentContent ? `${currentContent} <br>` : ``;
          setSummary(updatedContent);
        }
        resetTranscript();
        break;

      default:
        if (prevSummary) {
          const currentContent = prevSummary;
          const updatedContent = currentContent
            ? `${currentContent} ${command}<br>`
            : `${command}<br>`;
          setSummary(updatedContent);
        }

        break;
    }
  };
  const handleActiveSectionVoiceCommand = (command, activeSection) => {
    console.log("Active section and command in active", activeSection, command);
    switch (command.toLowerCase()) {
      default:
        resetTranscript();
        break;
    }
  };

  const startListening = () => {
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    setPrevSummary(summary !== null ? summary : "");
    setListeningOn(true);
  };

  const resetTextArea = () => {
    resetTranscript();
  };

  const handleVoiceRecognition = () => {
    if (transcript) {
      if (transcript.toLowerCase().trim().endsWith("insert line")) {
        handleVoiceCommand("insert line");
      } else if (transcript.toLowerCase().includes("replace")) {
        // handleReplace(transcript);
      } else {
        handleVoiceCommand(transcript);
      }

      // resetTranscript();
    }
  };
  const handleActiveSectionVoiceRecognition = (activeSection) => {
    console.log(
      "Active section and command from recognition function",
      activeSection,
      transcript,
    );

    if (transcript) {
      if (transcript.toLowerCase().trim().endsWith("insert line")) {
        handleActiveSectionVoiceCommand("insert line", activeSection);
      } else if (transcript.toLowerCase().includes("replace")) {
        // handleReplace(transcript);
      } else {
        handleActiveSectionVoiceCommand(transcript, activeSection);
      }

      // resetTranscript();
    }
  };

  useEffect(() => {
    let timerId;

    if (summaryDrawerOpen) {
      timerId = setTimeout(() => {
        handleVoiceRecognition();
      }, 3000);
    } else {
      timerId = setTimeout(() => {
        console.log(
          "Summary drawer not open but the transcript is",
          transcript,
        );
        handleActiveSectionVoiceRecognition(activeSection);
      }, 3000);
    }

    return () => {
      clearTimeout(timerId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transcript]);

  const summaryConfig = useMemo(
    () => ({
      buttons: "",
      minHeight: "300px",
      toolbar: false,
      showPlaceholder: false,

      style: {
        marginBottom: "10px",
        marginTop: "20px",
        border: "2px solid #c3e8e5",
        borderRadius: "10px",
        padding: "20px",
        width: "100%",
        fontSize: "12px",
        lineHeight: "1.5",
        color: "rgba(0, 0, 0, 0.87)",
        backgroundColor: "#FFFFFF",
        fontFamily: "Robota, Verdana, Source Sans Pro, sans-serif",
      },

      showXPathInStatusbar: false,
      showCharsCounter: false,
      showWordsCounter: false,
      toolbarAdaptive: false,

      enableDragAndDropFileToEditor: true,
    }),
    [],
  );

  const handleActiveSectionChange = (section) => {
    // Check if the current section is "Examinations" and validate data
    if (activeSection === "Examinations") {
      const hasInvalidData = vitals.some((vital) => {
        if (vital.name === "BP") {
          return vital.value && !/^\d{1,3}\/\d{1,3}$/.test(vital.value);
        } else {
          return (
            vital.value &&
            (!/^\d+(\.\d+)?$/.test(vital.value) || parseFloat(vital.value) <= 0)
          );
        }
      });

      // If there's invalid data, prevent section change
      if (hasInvalidData) {
        console.log("Invalid data detected. Cannot change section.");
        return;
      }
    }

    if (activeSection === "InitialObservation") {
      const panelData = selectedSectionsData.InitialObservation || [];

      const hasInvalidData = panelData.some((panel) =>
        panel.tests.some(
          (test) =>
            !test.value ||
            !/^\d+(\.\d+)?$/.test(test.value) || // numeric check
            !test.unit, // empty unit check
        ),
      );

      if (hasInvalidData) {
        console.log("Initial Observation has invalid entries. Cannot proceed.");
        return;
      }
    }
    console.log(
      "Appointment Error Dc",
      referralError,
      Object.keys(referralError).length,
    );

    if (
      (activeSection == "Follow Up/Referral" &&
        Object.keys(followUpError).length != 0) ||
      Object.keys(referralError).length != 0 ||
      Object.keys(ipdReferralError).length != 0
    ) {
      return;
    }

    // If validation passes, or if the section is not "Examinations", change the section
    if (activeSection !== section) {
      console.log("Prev Active Section", activeSection);
      setPrevActiveSection(activeSection);
      setActiveSection(section);
    }
  };

  const handleTimelineDrawerToggle = () => {
    setTimelineDrawerOpen(!timelineDrawerOpen);
  };
  const handleTimelineDrawerClose = () => {
    setTimelineDrawerOpen(false);
  };
  const handleSummaryDrawerOpen = () => {
    // console.log("Drawer Open ");
    setSummaryDrawerOpen(true);
  };

  const handleSummaryDrawerClose = () => {
    setSummaryDrawerOpen(false);
  };

  // const handleDrawerOpen = () => {
  //   setDrawerOpen(true);
  // };

  // const handleDrawerClose = () => {
  //   setDrawerOpen(false);
  // };

  // const handleMedicalSectionClick = (section) => {
  //   setSelectedMedicalSection(section);
  //   // Logic to display the content of the selected medical section
  //   // For example: set content based on the selected section
  //   // setContentBasedOnSection(section);
  // };

  const printRef = useRef();
  const printPrescRef = useRef();

  const handlePrint = (withHeaders, type) => {
    // Route to PrintPrescriptionforButtonDropdown for Prescription type
    if (type === "Prescription") {
      if (printPrescRef.current) {
        printPrescRef.current.print(withHeaders, type);
      }
    } else {
      // Route to PrintPrescription for OpConsultation and other types
      if (printRef.current) {
        printRef.current.print(withHeaders, type);
      }
    }
  };
  // // Prescription Print Handler for Dropdown
  // const handlePrescriptionPrint = (withHeaders) => {
  //   try {
  //     if (printPrescRef.current) {
  //       printPrescRef.current.print(withHeaders);
  //     }
  //   } catch (error) {
  //     console.error("Error printing prescription:", error);
  //     toast.error("Failed to print prescription. Please try again.");
  //   }
  // };

  const submitSummary = async () => {
    // console.log("onSubmit");
    var postBody = {
      content:
        "Doctor and patient had a conversation,from the conversation you please suggest what will be the suggestion we should keep for the fields in prescription pointwise 1.Chief Complaints.The suggestions for Chief Complaint should be short , compact and comma separated dont use conjuctions like and n all.Give response in one row like Chief Complaints:sug1,sug2...etc",
    };
    postBody.content += ` Conversation: ${summary}`;

    if (Token()) {
      try {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}generate_gemini_text/`,
          postBody,
          { headers: headers },
        );
        if (response) {
          console.log("Gemini Response", response);
          const updatedSuggestions = { ...suggestions };

          // Split the API response text into sections
          const sections = response.data.answer
            .split(/\d+\.\s+/)
            .filter(Boolean);

          console.log("Sections", sections);
          sections.forEach((section) => {
            const [sectionName, sectionContent] = section.split(":");
            const trimmedSectionName = sectionName.trim();
            const trimmedSectionContent = sectionContent.trim();

            if (updatedSuggestions.hasOwnProperty(trimmedSectionName)) {
              const suggestionsToAdd = trimmedSectionContent
                .split(",")
                .map((item) => item.trim())
                .filter((newSuggestion) => {
                  // Check if the new suggestion already exists in existing suggestions' aiDriven array
                  return !updatedSuggestions[trimmedSectionName].aiDriven.some(
                    (existingSuggestion) =>
                      existingSuggestion.name === newSuggestion,
                  );
                })
                .map((newSuggestion) => ({
                  name: newSuggestion,
                  activate: false,
                  removed: false,
                  status: "active",
                }));

              // Add new suggestions to the aiDriven property of the section
              updatedSuggestions[trimmedSectionName].aiDriven = [
                ...updatedSuggestions[trimmedSectionName].aiDriven,
                ...suggestionsToAdd,
              ];
            }
          });

          // Set the updated suggestions state
          setSuggestions(updatedSuggestions);
        }
      } catch (err) {
        console.log(err);
        toast.error(err);
      }
    }
  };
  const openPreviewModal = () => {
    // Filter out the Attachments section
    const sectionsWithoutAttachments = Object.keys(selectedSectionsData)
      .filter((key) => key !== "Attachments")
      .reduce((result, key) => {
        result[key] = selectedSectionsData[key];
        return result;
      }, {});

    // Check if any section except Attachments has content
    const hasContent =
      Object.values(sectionsWithoutAttachments).some((value) =>
        Array.isArray(value) ? value.length > 0 : value !== "",
      ) || checkTotalHistoryData();

    if (hasContent) {
      setPreviewPrescription(true);
    } else {
      setOpenSnackBar(true);
    }
  };

  const checkTotalHistoryData = () => {
    for (const category in medicalBackground) {
      const { prev, new: newData } = medicalBackground[category];
      if (prev.length > 0) return true;
      if (newData.length > 0) return true;
    }
    return false;
  };
  const handleCloseSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };

  const closePreviewModal = () => {
    setPreviewPrescription(false);
    setPreviewTab(1);
  };

  const get_care_contexts = () => {
    if (isAbdmEnabled == "true") {
      var post_data = {};
      if (Token()) {
        post_data.filter_type = "patient_abha";
        post_data.filter_details = {};
        post_data.filter_details.patient_abha = state?.patientData.abha_id;
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}fetch_care_contexts_by_filter/`,
            JSON.stringify(post_data),
            {
              headers: headers,
            },
          )
          .then((res) => {
            if (res.data.status !== "Failed") {
              console.log("Visit Purpose Result", res.data);
              if (res.data.care_contenxts.length <= 0) {
                toast.error("No Visit Purpose.");
              }
              console.log("Visit Purpose", res.data.care_contenxts);
              setCare_context_list(res.data.care_contenxts);
            }
            //ChangeCursor();
          });
      }
    } else {
      var post_data = {};
      if (Token()) {
        post_data.filter_type = "patient_id";
        post_data.filter_details = {};
        post_data.filter_details.patient_id = state?.patientData.patient_id;
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}fetch_care_contexts_by_filter/`,
            JSON.stringify(post_data),
            {
              headers: headers,
            },
          )
          .then((res) => {
            if (res.data.status !== "Failed") {
              console.log("Visit Purpose Result", res.data);
              if (res.data.care_contenxts.length <= 0) {
                toast.error("No Visit Purpose.");
              }
              console.log("Visit Purpose", res.data.care_contenxts);
              setCare_context_list(res.data.care_contenxts);
            }
            //ChangeCursor();
          });
      }
    }
  };
  useEffect(() => {
    get_care_contexts();
  }, []);
  useEffect(() => {
    // Set defaultValue to the first value in the list when care_context_list changes
    if (care_context_list && care_context_list.length > 0) {
      setSelectedContext(care_context_list[0].care_context_reference);
      setSelectedContextDisplay(care_context_list[0].display);
    }
  }, [care_context_list]);
  const AddCareContextCloseModal = () => {
    setAddCareContextModalOpen(false);
    setValue("visit_details", ""); // Set the value of the partner_name field
  };
  const AddCareContext = (data, e) => {
    e.preventDefault();
    console.log("Abdm Enablement", isAbdmEnabled, typeof isAbdmEnabled);
    if (Token()) {
      const reqBody = {
        patient_id: state?.patientData.patient_id,
        visit_details: getValues3("visit_details"),
        care_context_created_at: isTodayOrFuture(state?.dateForAppointment)
          ? null //will take real time in backend
          : (() => {
              //else will take date from dateForAppointment and time from the start time
              const [hours, minutes] = state?.startTime
                .slice(11, 16) // "HH:mm"
                .split(":")
                .map(Number);

              // Create local date (IST)
              const date = new Date(
                state?.dateForAppointment.getFullYear(),
                state?.dateForAppointment.getMonth(),
                state?.dateForAppointment.getDate(),
                hours,
                minutes,
              );

              const pad = (n) => String(n).padStart(2, "0");

              // Return UTC but same format
              return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(
                date.getUTCDate(),
              )} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
            })(),
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}create_care_context/`,
          JSON.stringify(reqBody),
          {
            headers: headers,
          },
        )
        .then((res) => {
          console.log("Add Visit Purpose", res.data);
          if (res.data.status === "Success") {
            console.log(res);
            toast.success(
              `Visit Purpose Reference Id "${res.data.ref_num}" This ID will be used for linking to ABDM.`,
            );
            get_care_contexts();
            setValue3("visit_details", "");
            AddCareContextCloseModal();
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
      // }
    }
  };

  const handleCrossButtonClick = (section, suggestion, suggestionType) => {
    const updatedSuggestions = { ...suggestions }; // Create a copy of the initialSuggestions object
    console.log("Updated Suggestionsss", updatedSuggestions);
    // Find the section in suggestions
    const sectionData = updatedSuggestions[section];
    if (sectionData) {
      // Find the selected suggestion by its name in the specified suggestionType (aiDriven or ruleDriven)
      const selectedSuggestion = sectionData[suggestionType].find(
        (sug) => sug.name === suggestion,
      );

      if (selectedSuggestion) {
        // Update the 'activate' field to true for the selected suggestion
        selectedSuggestion.removed = true;

        // Set the updated suggestions state
        setSuggestions(updatedSuggestions);
      }
    }
  };

  function convertToISOString(dateString) {
    // Parse the input date string
    var parsedDate = new Date(dateString);

    // Check if the parsing was successful
    if (isNaN(parsedDate.getTime())) {
      return "Invalid Date";
    }

    // Convert to ISO string format
    var isoString = parsedDate.toISOString();

    return isoString;
  }

  const postCoordinateOfCode = (investigation) => {
    const { id, body_part_id, laterality_id, position_id } = investigation;

    if (!id) return null;

    const modifiers = [];

    if (body_part_id) modifiers.push(`363698007=${body_part_id}`); //for body part/finding site(363698007)
    if (laterality_id) modifiers.push(`272741003=${laterality_id}`); //for laterality(272741003)
    if (position_id) modifiers.push(`246268007=${position_id}`); //for position(246268007)

    return modifiers.length ? `${id}:${modifiers.join(",")}` : id;
  };
  const postCoordinateOfTerm = (investigation) => {
    const { term, body_part, laterality, position } = investigation;

    if (!term) return null;

    const modifiers = [];

    if (body_part) modifiers.push(`Finding site=${body_part}`); //for body part/finding site(363698007)
    if (laterality) modifiers.push(`Laterality=${laterality}`); //for laterality(272741003)
    if (position) modifiers.push(`Position=${position}`); //for position(246268007)

    return modifiers.length ? `${term}:${modifiers.join(",")}` : term;
  };

  /**
   * Hands control back to the browser long enough for it to paint. PDF
   * generation resumes on the microtask queue, and microtasks drain before any
   * paint, so without a macrotask hop the "Submitting..." render stays invisible
   * until the several seconds of jsPDF/html2canvas work are already done.
   */
  const yieldToBrowserPaint = () =>
    new Promise((resolve) => {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        resolve();
      };
      requestAnimationFrame(() => setTimeout(finish, 0));
      // rAF is paused in background tabs; never let that stall a submission.
      setTimeout(finish, 50);
    });

  /**
   * Keeps the Submit button disabled/"Submitting..." until the whole submission
   * chain settles, and swallows double clicks while one is already in flight.
   */
  const prescriptionSubmitHandler = async () => {
    if (isSubmittingPrescriptionRef.current) return;
    isSubmittingPrescriptionRef.current = true;
    setIsSubmittingPrescription(true);
    try {
      await yieldToBrowserPaint();
      await runPrescriptionSubmit();
    } catch (err) {
      console.log(err);
    } finally {
      isSubmittingPrescriptionRef.current = false;
      setIsSubmittingPrescription(false);
    }
  };

  const runPrescriptionSubmit = async () => {
    if (care_context_list.length > 0) {
      //op-chief compl(Condition),procedures,medications,Examinations(service req)
      //pres-chief complaints,medications
      //well-vitals
      const transcribeInput = document.getElementById("transcribeId");
      const prescriptionInput = document.getElementById("prescriptionId");
      const wellnessInput = document.getElementById("wellnessId");
      const opConsultationInput = document.getElementById("opConsultationId");
      var transcribeBase64, prescriptionBase64, wellnessBase64, opBase64;
      // Returned so the caller can await the full chain before re-enabling Submit.
      return Promise.all([
        generatePdfBase64(transcribeInput, "Transcription.pdf"),
        prescriptionPdfRef.current.generatePrescriptionPdf(),
        wellnessPdfRef.current.generateWellnessPdf(),
        PrescriptionPdfPdfRef.current.generateOpPdf(),
        printPrescRef.current
          ? printPrescRef.current
              .generatePrescriptionPdfForSubmission()
              .catch((e) => {
                console.error(
                  "Prescription (print layout) PDF for OP attachments failed:",
                  e,
                );
                return null;
              })
          : Promise.resolve(null),
      ])
        .then(
          ([
            transcribeBase64Result,
            prescriptionBase64Result,
            wellnessBase64Result,
            opConsultationResult,
            printPrescDropdownBase64Result,
          ]) => {
            transcribeBase64 = transcribeBase64Result;
            prescriptionBase64 = prescriptionBase64Result;
            wellnessBase64 = wellnessBase64Result;
            opBase64 = opConsultationResult;
            const printPrescDropdownBase64 = printPrescDropdownBase64Result;
            // console.log("Transcribe", transcribeBase64);
            // console.log("Prescription", prescriptionBase64);
            const hip = facility_id;
            console.log(
              "dateForAppointment in prescription submit handler",
              state?.dateForAppointment,
            );
            console.log("startTime", startTime);
            //getting the time in start time in ist
            const currentDate = isTodayOrFuture(state?.dateForAppointment)
              ? new Date().toISOString()
              : (() => {
                  // Extract IST hours/minutes from startTime string
                  const [hoursIST, minutesIST] = state?.startTime
                    .slice(11, 16) // "HH:mm"
                    .split(":")
                    .map(Number);

                  // Convert IST to UTC
                  let hoursUTC = hoursIST - 5;
                  let minutesUTC = minutesIST - 30;
                  if (minutesUTC < 0) {
                    minutesUTC += 60;
                    hoursUTC -= 1;
                  }

                  return new Date(
                    Date.UTC(
                      state?.dateForAppointment.getFullYear(),
                      state?.dateForAppointment.getMonth(),
                      state?.dateForAppointment.getDate(),
                      hoursUTC,
                      minutesUTC,
                    ),
                  ).toISOString();
                })();

            // Start the critical path API call immediately while the rest of the
            // payload is assembled (network runs in parallel with CPU work below).
            const pastVisitPromise = axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}add_past_visit/`,
              {
                hip_id: hip,
                care_context_id: selectedContext,
                patient_id: state?.patientData.patient_id,
                visit_datetime: currentDate,
                doctor_id: state?.doctorData.doctor_id,
                prescription: prescriptionBase64.split(";base64,").pop(),
                summary: "",
                transcribe: transcribeBase64.split(";base64,").pop(),
              },
              { headers },
            );
            const chiefComplaintsObject = {
              resource_type: "Encounter",
              encounter_id: selectedContext, // Generate encounter ID as needed
              start_date: currentDate,
              end_date: currentDate,
            };

            // console.log("Chief Complaints ", chiefComplaints);
            const testsAndInvestigations =
              selectedSectionsData["Tests/Investigations"];
            const opTestsAndInvestigations = selectedSectionsData[
              "Tests/Investigations"
            ].map((examination) => ({
              resource_type: "ServiceRequest",
              category_code: "108252007",
              category: "Laboratory procedure",
              service_code: postCoordinateOfCode(examination),
              service_description: postCoordinateOfTerm(examination),
              service_text: `${examination.term}${
                examination?.body_part ? `, ${examination.body_part}` : ""
              }${examination?.laterality ? `, ${examination.laterality}` : ""}${
                examination?.position ? `, ${examination.position}` : ""
              }`,
              recorded_date: currentDate,
              note: examination?.clinical_note
                ? examination.clinical_note
                : null,
            }));
            const diagnosis = selectedSectionsData["Diagnosis"];
            const opConditionsChiefComplaints = selectedSectionsData[
              "Chief Complaints"
            ]
              // .filter((item) => item.onset_datetime)
              .map((suggestion) => ({
                resource_type: "Condition",
                clinical_status_description:
                  suggestion.clinical_status_description,
                disease_code: suggestion.id,
                onset_datetime: suggestion.onset_datetime,
                abatement_datetime:
                  suggestion.abatement_datetime !== null
                    ? suggestion.abatement_datetime
                    : null,
                note:
                  suggestion.clinical_note.length > 0
                    ? suggestion.clinical_note
                    : null,

                disease_description: suggestion.condition, //diagnosis name
                recorded_date: currentDate,
              }));

            // console.log("Prescribed Medicines ", prescribedMedicines);

            const medications = selectedSectionsData["Medications"].map(
              (medicine) => {
                const startDate = state?.dateForAppointment; // Get today's date

                let endDate = new Date(startDate); // Set the endDate initially to startDate

                // Calculate endDate based on the duration provided
                const medicationDuration = String(
                  medicine.duration || "",
                ).trim();
                const medDurValue = parseInt(medicationDuration, 10);
                const medDurUnitMatch = medicationDuration
                  .toLowerCase()
                  .match(/\b(minutes?|hours?|days?|weeks?|months?|years?)\b/);
                const medDurType = medDurUnitMatch ? medDurUnitMatch[1] : "";
                if (medDurType.startsWith("minute")) {
                  endDate.setMinutes(endDate.getMinutes() + medDurValue);
                } else if (medDurType.startsWith("hour")) {
                  endDate.setHours(endDate.getHours() + medDurValue);
                } else if (medDurType.startsWith("day")) {
                  endDate.setDate(startDate.getDate() + medDurValue);
                } else if (medDurType.startsWith("week")) {
                  endDate.setDate(startDate.getDate() + medDurValue * 7);
                } else if (medDurType.startsWith("month")) {
                  endDate.setMonth(startDate.getMonth() + medDurValue);
                } else if (medDurType.startsWith("year")) {
                  endDate.setFullYear(startDate.getFullYear() + medDurValue);
                }
                const HIPId = hip;
                // Update the structure of each medicine object

                return {
                  HIPID: HIPId,
                  // disease_details: [...disease_details],
                  medication_id: medicine.id,
                  startdate: convertToISOString(startDate),
                  enddate: convertToISOString(endDate),
                  drug_name_poe: medicine.term,
                  formulary_drug_cd: "",
                  prod_strength: "",
                  dose_val_rx: "",
                  dose_unit_rx: "",
                  form_val_disp: [
                    [medicine.time, medicine.when].filter(Boolean).length > 0
                      ? `Timing: ${[medicine.time, medicine.when].filter(Boolean).join(" ")}`
                      : null,
                    medicine.frequency
                      ? `Frequency: ${medicine.frequency}`
                      : null,
                    medicine.dosage ? `Dosage: ${medicine.dosage}` : null,
                    Array.isArray(medicine.additionalInstructions)
                      ? medicine.additionalInstructions.length > 0
                        ? `Additional Instructions: ${medicine.additionalInstructions.map((item) => item.term).join(", ")}`
                        : null
                      : medicine.additionalInstructions
                        ? `Additional Instructions: ${medicine.additionalInstructions}`
                        : null,

                    medicationDuration
                      ? `Duration: ${medicationDuration}`
                      : null,

                    medicine.medicineNote
                      ? `Note: ${medicine.medicineNote}`
                      : null,
                  ]
                    .filter(Boolean)
                    .join(" | "),
                  form_unit_disp: "",
                  route: medicine.selectedAdministration?.label ?? "",
                  reason:
                    medicine.reasons.length > 0
                      ? medicine.reasons.map((reason) => ({
                          disease_name: reason,
                        }))
                      : null,
                };
              },
            );
            const opMedications = selectedSectionsData["Medications"].map(
              (medicine) => {
                const {
                  id,
                  term,
                  selectedAdministration,
                  recorded_date,
                  reasons,
                  frequency,
                  dosage,
                  time,
                  when,
                  additionalInstructions,
                  duration,
                  medicineNote,
                } = medicine;
                const medicationDuration = duration;

                const additionalInstruction = [
                  [time, when].filter(Boolean).length > 0
                    ? `Timing: ${[time, when].filter(Boolean).join(" ")}`
                    : null,
                  frequency ? `Frequency: ${frequency}` : null,
                  dosage ? `Dosage: ${dosage}` : null,
                  Array.isArray(additionalInstructions)
                    ? additionalInstructions.length > 0
                      ? `Additional Instructions: ${additionalInstructions.map((item) => item.term).join(", ")}`
                      : null
                    : additionalInstructions
                      ? `Additional Instructions: ${additionalInstructions}`
                      : null,

                  medicationDuration ? `Duration: ${medicationDuration}` : null,
                ]
                  .filter(Boolean)
                  .join(" | ");

                return {
                  resource_type: "MedicationRequest", // or "MedicationStatement" based on your data
                  medication_code: id,
                  drug_name: term,
                  additional_instruction: additionalInstruction,
                  route_description: selectedAdministration?.label ?? null,
                  route_code: selectedAdministration?.id ?? null,
                  recorded_date: currentDate,
                  note: medicineNote ? medicineNote : null,
                  reason:
                    reasons.length > 0
                      ? reasons.map((reason) => ({
                          disease_name: reason,
                        }))
                      : null,
                };
              },
            );
            const pharmacyMedications = selectedSectionsData["Medications"].map(
              (medicine) => {
                const {
                  id,
                  term,

                  frequency,
                  dosage,
                  time,
                  when,
                  additionalInstructions,
                  duration,

                  medicineNote,
                } = medicine;
                const medicationDuration = duration;

                const parsedosage = [
                  [time, when].filter(Boolean).length > 0
                    ? `Timing: ${[time, when].filter(Boolean).join(" ")}`
                    : "",
                  frequency ? `Frequency: ${frequency}` : "",
                  dosage ? `Dosage: ${dosage}` : "",
                  Array.isArray(additionalInstructions)
                    ? additionalInstructions.map((item) => item.term).join(", ")
                    : additionalInstructions || "",
                  medicationDuration ? `for ${medicationDuration}` : "",
                  // instructions || "",
                  // medicineNote || "",
                ]
                  .filter(Boolean)
                  .join(" ");

                return {
                  snomed_id: id,
                  name: term,
                  dosage: parsedosage,
                  note: medicineNote ? medicineNote : null,
                };
              },
            );
            console.log("Op Medications", opMedications);
            console.log("Prescription Medications", medications);
            // const advices = extractListItems(sectionsContent["Advices"]);
            // const procedures = extractListItems(sectionsContent["Procedures"]);
            const opProcedures = selectedSectionsData["Procedures"].map(
              (procedure) => ({
                resource_type: "ServiceRequest",
                category_code: "108252007",
                category: "Laboratory procedure",
                service_code: procedure.id,
                service_description: procedure.term,
                recorded_date: currentDate,
                note: procedure.clinical_note,

                // recorded_date: currentDate,
              }),
            );

            let transformedVitals = [];
            let height, weight;

            // Find the values of height and weight
            vitals.forEach((vital) => {
              if (vital.codeDisplay === "Body height" && vital.value) {
                height = parseFloat(vital.value);
              } else if (vital.codeDisplay === "Body weight" && vital.value) {
                weight = parseFloat(vital.value);
              }
            });

            transformedVitals = vitals.flatMap((vital) => {
              const category_description = vital.categoryDisplay;
              const category_code = vital.categoryDisplay
                .toLowerCase()
                .replace(" ", "-");
              const observationID = vital.id;
              const effectiveDateTime = formatDateYYYYMMDD(
                state?.dateForAppointment?.toISOString(),
              );
              const testValue = vital.value;
              const unit = vital.unit;
              const unitCode = vital.unitCode;

              let interpretationCode, interpretationDisplay;

              if (vital.codeDisplay === "Oxygen saturation in Arterial blood") {
                // Interpretation for SPO2
                const lowerLimitSpo2 = parseFloat(vital.lowerLimit);
                const upperLimitSpo2 = parseFloat(vital.upperLimit);
                const spo2Value = parseFloat(testValue);

                if (spo2Value < lowerLimitSpo2) {
                  interpretationCode = "L";
                  interpretationDisplay = "Low";
                } else if (spo2Value > upperLimitSpo2) {
                  interpretationCode = "H";
                  interpretationDisplay = "High";
                } else {
                  interpretationCode = "N";
                  interpretationDisplay = "Normal";
                }
              } else if (
                vital.codeDisplay ===
                "Blood pressure panel with all children optional"
              ) {
                // Interpretation for Blood Pressure (BP)
                const [systolic, diastolic] = testValue
                  .split("/")
                  .map((val) => parseInt(val));
                const lowerLimitSystolic = parseInt(
                  vital.lowerLimit.split("/")[0],
                );
                const upperLimitSystolic = parseInt(
                  vital.upperLimit.split("/")[0],
                );
                const lowerLimitDiastolic = parseInt(
                  vital.lowerLimit.split("/")[1],
                );
                const upperLimitDiastolic = parseInt(
                  vital.upperLimit.split("/")[1],
                );

                const systolicVital = {
                  type: vital.type,
                  // observationID: "systolic-blood-pressure",
                  observation_code: null,
                  observation_description: "Systolic blood pressure",
                  category_code,
                  category_description,
                  interpretation_code:
                    systolic < lowerLimitSystolic ||
                    systolic > upperLimitSystolic
                      ? "H"
                      : "N",
                  interpretation_description:
                    systolic < lowerLimitSystolic ||
                    systolic > upperLimitSystolic
                      ? "High"
                      : "Normal",
                  value_quantity: isNaN(systolic) ? null : systolic,
                  value_string: null,
                  value_boolean: null,
                  lower_limit: lowerLimitSystolic,

                  upper_limit: upperLimitSystolic,

                  unit_code: unitCode,
                  unit,
                  observation_date: effectiveDateTime,
                  value_codeable_concept: null,
                };

                const diastolicVital = {
                  type: vital.type,
                  // observationID: "diastolic-blood-pressure",
                  observation_code: null,
                  observation_description: "Diastolic blood pressure",
                  category_code,
                  category_description,
                  interpretationCode:
                    diastolic < lowerLimitDiastolic ||
                    diastolic > upperLimitDiastolic
                      ? "H"
                      : "N",
                  interpretationDisplay:
                    diastolic < lowerLimitDiastolic ||
                    diastolic > upperLimitDiastolic
                      ? "High"
                      : "Normal",
                  value_quantity: isNaN(diastolic) ? null : diastolic,
                  value_string: null,
                  value_boolean: null,
                  lower_limit: lowerLimitDiastolic,

                  upper_limit: upperLimitDiastolic,

                  unit_code: unitCode,
                  unit,
                  observation_date: effectiveDateTime,
                  value_codeable_concept: null,
                };

                return [systolicVital, diastolicVital];
              } else {
                interpretationCode = null;
                interpretationDisplay = null;
              }

              let loinc = null;

              const lowerLimit = null;
              const lowerLimitCode = null;
              const upperLimit = null;
              const upperLimitCode = null;
              const status = "final";

              return {
                type: vital.type,
                // observationID,
                observation_code: loinc,
                observation_description: vital.codeDisplay,
                category_code,
                category_description,
                interpretation_code: interpretationCode,
                interpretation_description: interpretationDisplay,
                value_quantity: testValue,
                value_string: null,
                value_boolean: null,
                lower_limit: lowerLimit,

                upper_limit: upperLimit,

                unit_code: unitCode,
                unit,
                observation_date: effectiveDateTime,
                value_codeable_concept: null,
              };
            });
            if (height && weight) {
              const heightInMeters = parseFloat(height) / 100;
              weight = parseFloat(weight);
              const bmi = weight / (heightInMeters * heightInMeters);

              transformedVitals.push({
                type: "BodyMeasurement",
                // observationID: "bmi",
                observation_code: null,
                observation_description: "Body mass index (BMI) [Ratio]",
                category_code: "vital-signs",
                category_description: "Vital Signs",
                interpretationCode: bmi < 18.5 ? "L" : bmi > 25 ? "H" : "N",
                interpretationDisplay:
                  bmi < 18.5 ? "Low" : bmi > 25 ? "High" : "Normal",
                value_quantity: bmi.toFixed(1),
                value_string: null,
                value_boolean: null,
                lowerLimit: 18.5,

                upperLimit: 25,

                unit_code: "kg/m2",
                unit: "kg/m2",
                observation_date: state?.dateForAppointment
                  ?.toISOString()
                  .substring(0, 10),
                value_codeable_concept: null,
              });
            }
            if (bloodGroup !== null) {
              transformedVitals.push({
                type: "OtherObservations",
                // observationID: "blood-group",
                observation_code: null,
                observation_description: "Blood Group",
                category_code: null,
                category_description: null,
                interpretationCode: null,
                interpretationDisplay: null,
                value_quantity: null,
                value_string: bloodGroup,
                value_boolean: null,
                lowerLimit: null,
                upperLimit: null,
                unit_code: null,
                unit: null,
                observation_date: state?.dateForAppointment
                  ?.toISOString()
                  .substring(0, 10),
              });
            }
            const otherExaminationsText = otherExaminations?.trim();
            if (otherExaminationsText) {
              transformedVitals.push({
                type: "OtherObservations",
                observation_code: null,
                observation_description: "Other Examinations",
                category_code: null,
                category_description: null,
                interpretationCode: null,
                interpretationDisplay: null,
                value_quantity: null,
                value_string: otherExaminationsText,
                value_boolean: null,
                lowerLimit: null,
                upperLimit: null,
                unit_code: null,
                unit: null,
                observation_date: state?.dateForAppointment
                  ?.toISOString()
                  .substring(0, 10),
                value_codeable_concept: null,
              });
            }
            console.log("Diagnosis Details", diagnosis);
            diagnosis.map((diag) => {
              transformedVitals.push({
                type: "OtherObservations",
                // observationID: diag.term.split(" ").join("-").toLowerCase(),
                observation_code: null,
                observation_description: "Diagnosis",
                category_code: null,
                category_description: null,
                interpretationCode: null,
                interpretationDisplay: null,
                value_quantity: null,
                value_string: diag.term,
                value_boolean: null,
                lowerLimit: null,
                note:
                  [
                    (() => {
                      const diagDuration = diag.duration;
                      return diagDuration ? `Duration: ${diagDuration}` : null;
                    })(),
                    diag.clinical_note ? `Note: ${diag.clinical_note}` : null,
                  ]
                    .filter(Boolean)
                    .join(" | ") || undefined,
                upperLimit: null,

                unit_code: null,
                unit: null,
                observation_date: state?.dateForAppointment
                  ?.toISOString()
                  .substring(0, 10),
                value_codeable_concept: null,
              });
            });
            if (bloodGroup && bloodGroup !== bloodGroupFirstTime) {
              axios
                .post(
                  `${REACT_APP_BACKEND_ROUTE_URL}add_patient_static_data/`,
                  {
                    hip_id: hip,
                    patient_id: state?.patientData.patient_id,
                    blood_group: bloodGroup,
                  },
                  {
                    headers: headers,
                  },
                )
                .then((response) => {
                  console.log("Patient Static Data Submit Log", response.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            const opAttachments = selectedSectionsData["Attachments"].map(
              (attachment) => {
                // Extract the name without extension
                let nameWithoutExtension = attachment.name.substring(
                  0,
                  attachment.name.lastIndexOf("."),
                );
                nameWithoutExtension = nameWithoutExtension.replace(/_/g, "-"); // Replace underscores with hyphens
                nameWithoutExtension = nameWithoutExtension.replace(
                  /\s+/g,
                  "-",
                ); // Replace continuous spaces with one hyphen
                console.log("nameWithoutExtension", nameWithoutExtension);
                // Extract the type from MIME type
                const type = attachment.type.split("/")[1]; // Extracts the part after '/'
                // Combine the name and type to form a new name
                const newName = `Op_${nameWithoutExtension}_${uuidv4().slice(
                  0,
                  7,
                )}.${type}`;

                return {
                  file: {
                    type: attachment.type,
                    data: attachment.base64.split(";base64,").pop(),
                    name: newName,
                  },
                };
              },
            );
            opAttachments.push({
              file: {
                type: "application/pdf",
                data: opBase64.split(";base64,").pop(),
                name: `Op_Consultation_${uuidv4().slice(0, 7)}.pdf`,
              },
            });
            if (printPrescDropdownBase64) {
              opAttachments.push({
                file: {
                  type: "application/pdf",
                  data: printPrescDropdownBase64.split(";base64,").pop(),
                  name: `old_record_pres.pdf`,
                },
              });
            }
            console.log("Op Attachments", opAttachments);

            const opAttachmentsEmails = selectedSectionsData["Attachments"].map(
              (attachment) => {
                // Extract the name without extension
                let nameWithoutExtension = attachment.name.substring(
                  0,
                  attachment.name.lastIndexOf("."),
                );
                nameWithoutExtension = nameWithoutExtension.replace(/_/g, "-"); // Replace underscores with hyphens
                nameWithoutExtension = nameWithoutExtension.replace(
                  /\s+/g,
                  "-",
                ); // Replace continuous spaces with one hyphen
                console.log("nameWithoutExtension", nameWithoutExtension);

                // Extract the type from MIME type
                const type = attachment.type.split("/")[1]; // Extracts the part after '/'

                // Combine the name and type to form a new name
                const newName = `${nameWithoutExtension}_Op_Consult.${type}`;

                return {
                  FILE: attachment.base64.split(";base64,").pop(),
                  FILENAME: newName,
                };
              },
            );
            opAttachmentsEmails.push({
              FILE: opBase64.split(";base64,").pop(),
              FILENAME: `Op_Consultation_${uuidv4().slice(0, 7)}.pdf`,
            });
            if (printPrescDropdownBase64) {
              opAttachmentsEmails.push({
                FILE: printPrescDropdownBase64.split(";base64,").pop(),
                FILENAME: `old_record_pres.pdf`,
              });
            }
            const familyHistoryAllData = [
              ...medicalBackground["Family History"]["prev"],
              ...medicalBackground["Family History"]["new"],
            ];
            const familyHistoryNewData = [
              ...medicalBackground["Family History"]["new"],
            ];
            const medicalHistoryAllData = [
              ...medicalBackground["History of Past Illness"]["prev"],
              ...medicalBackground["History of Past Illness"]["new"],
            ];
            const medicalHistoryNewData = [
              ...medicalBackground["History of Past Illness"]["new"],
            ];
            const presentIllnessAllData = [
              ...medicalBackground["History of Present Illness"]["prev"],
              ...medicalBackground["History of Present Illness"]["new"],
            ];
            const presentIllnessNewData = [
              ...medicalBackground["History of Present Illness"]["new"],
            ];
            const surgicalHistoryAllData = [
              ...medicalBackground["Surgeries"]["prev"],
              ...medicalBackground["Surgeries"]["new"],
            ];
            const surgicalHistoryNewData = [
              ...medicalBackground["Surgeries"]["new"],
            ];
            const allergyHistoryAllData = [
              ...medicalBackground["Allergies"]["prev"],
              ...medicalBackground["Allergies"]["new"],
            ];
            const allergyHistoryNewData = [
              ...medicalBackground["Allergies"]["new"],
            ];
            const addictionHistoryAllData = [
              ...medicalBackground["Addiction History"]["prev"],
              ...medicalBackground["Addiction History"]["new"],
            ];
            const addictionHistoryNewData = [
              ...medicalBackground["Addiction History"]["new"],
            ];

            const drugHistoryAllData = [
              ...medicalBackground["Drug History"]["prev"],
              ...medicalBackground["Drug History"]["new"],
            ];
            const drugHistoryNewData = [
              ...medicalBackground["Drug History"]["new"],
            ];
            const menstrualHistoryAllData = [
              ...medicalBackground["Menstrual History"]["prev"],
              ...medicalBackground["Menstrual History"]["new"],
            ];
            const menstrualHistoryNewData = [
              ...medicalBackground["Menstrual History"]["new"],
            ];
            const adultVaccinationAllData = [
              ...medicalBackground["Adult Vaccination"]["prev"],
              ...medicalBackground["Adult Vaccination"]["new"],
            ];
            const adultVaccinationNewData = [
              ...(selectedSectionsData["Adult Vaccination"] || []),
              ...(medicalBackground["Adult Vaccination"]?.new || []),
            ];
            const isNewHistoryDataPresent =
              familyHistoryNewData.length > 0 ||
              allergyHistoryNewData.length > 0 ||
              addictionHistoryNewData.length > 0 ||
              drugHistoryNewData.length > 0 ||
              menstrualHistoryNewData.length > 0 ||
              medicalHistoryNewData.length > 0 ||
              // presentIllnessNewData.length > 0 ||
              surgicalHistoryNewData.length > 0 ||
              adultVaccinationNewData.length > 0;

            const familyHistory = {
              resource_type: "FamilyMemberHistory",
              family_member_details: familyHistoryAllData.map((data) => ({
                recorded_date: formatDateYYYYMMDD(currentDate) || null,
                relationship: data.relation.toLowerCase() || "family member",
                condition: data.condition || null,
                onset_age: data.onSetAge || null,
                contributed_to_death: data.deceased || null,
                note: `${data?.clinical_note?.length > 0 ? `${data.clinical_note}, ` : ""}${data.onset_duration ? `the condition started ${data.onset_duration} ago, ` : ""}${data.abatement_duration ? `the condition was present for ${data.abatement_duration}` : ""}`,
              })),
            };
            const medicalHistoryData = medicalHistoryAllData.map((data) => ({
              resource_type: "MedicalHistory",
              clinical_status_description: data.clinical_status_description,
              disease_code: data.id,
              onset_datetime: data.onset_datetime,
              abatement_datetime:
                data.abatement_datetime !== null
                  ? data.abatement_datetime
                  : null,
              note: `${data?.clinical_note?.length > 0 ? `${data.clinical_note}, ` : ""}${data.abatement_duration ? `the condition was present for ${data.abatement_duration}` : ""}`,

              disease_description: data.condition, //diagnosis name
              recorded_date: currentDate,
            }));

            const presentIllnessData = presentIllnessAllData.map((data) => ({
              resource_type: "MedicalHistory",
              clinical_status_description: data.clinical_status_description,
              disease_code: data.id,
              onset_datetime: data.onset_datetime,
              abatement_datetime:
                data.abatement_datetime !== null
                  ? data.abatement_datetime
                  : null,
              note: `${data?.clinical_note?.length > 0 ? `${data.clinical_note}, ` : ""}${data.abatement_duration ? `the condition was present for ${data.abatement_duration}` : ""}`,
              disease_description: data.condition,
              recorded_date: currentDate,
            }));

            const drugHistoryData = drugHistoryAllData.map((data) => ({
              resource_type: "MedicationStatement",
              medication_code: null,
              medication_name: data.drug_name,
              date_asserted: data.onset_datetime,
              start_date: null,
              end_date: null,
              reason: null,
              note: `${data?.clinical_note?.length > 0 ? `${data.clinical_note}, ` : ""}${data.condition_onset ? `the drug was started ${data.condition_onset} ago, ` : ""}${data.duration ? `the drug was taken for ${data.duration}` : ""}`,
            }));
            console.log("Drug History whole data", drugHistoryData);
            const surgicalHistoryData = surgicalHistoryAllData.map(
              (procedure) => ({
                resource_type: "SurgicalHistory",
                procedure_code: procedure.id,
                procedure_description: procedure.procedure,
                complication_description: null,
                follow_up_description:
                  procedure.follow_up_description !== ""
                    ? procedure.follow_up_description
                    : null,
                recorded_date: procedure.recorded_date,
                note: procedure.clinical_note,
              }),
            );
            // console.log(
            //   "Surgical History All Data",
            //   surgicalHistoryAllData,
            //   surgicalHistoryData
            // );
            const allergyHistory = {
              resource_type: "AllergyIntolerance",
              allergy_details: allergyHistoryAllData.map((data) => ({
                recorded_date: formatDateTime(currentDate),
                clinical_status_description: data.clinical_status_description,
                allergy_description: data.allergy_description,
                note: `${data?.note?.length > 0 ? `${data.note}, ` : ""}${data.condition_onset ? `the allergy started ${data.condition_onset} ago, ` : ""}${data.condition_duration ? `the allergy was present for ${data.condition_duration}` : ""}`,
                verification_status_description: "Confirmed",
                category: data.allergy_type ? data.allergy_type : null,
              })),
            };
            const menstrualHistoryArray = menstrualHistoryAllData.map(
              (data) => {
                return {
                  type: "WomenHealth",
                  observation_code: null,
                  observation_description: data.menstrualType,
                  category_code: null,
                  category_description: null,
                  interpretationCode: null,
                  interpretationDisplay: null,
                  value_quantity: null,
                  value_string: null,
                  value_codeable_concept: data.description,
                  lowerLimit: null,
                  upperLimit: null,
                  unit_code: null,
                  unit: null,
                  observation_date: data.date,
                };
              },
            );
            const addictionHistoryArray = addictionHistoryAllData.map(
              (data) => {
                return {
                  type: "Lifestyle",
                  observation_code: null,
                  observation_description: data.addiction_type,
                  category_code: null,
                  category_description: null,
                  interpretationCode: null,
                  interpretationDisplay: null,
                  value_quantity: null,
                  value_string: null,
                  value_codeable_concept: data.addiction_description,
                  lowerLimit: null,
                  upperLimit: null,
                  unit_code: null,
                  unit: null,
                  observation_date: data.onset_datetime,
                };
              },
            );

            const filteredObservations = transformedVitals.filter(
              (observation) => {
                return (
                  (observation.value_quantity !== null &&
                    observation.value_quantity !== "") ||
                  observation.value_string !== null
                );
              },
            );
            // if menstrual history present then add that to the filtered Observations
            if (menstrualHistoryArray.length > 0) {
              menstrualHistoryArray.map((data) => {
                filteredObservations.push(data);
              });
            }
            // if addiction history present then add that to the filtered Observations
            if (addictionHistoryArray.length > 0) {
              addictionHistoryArray.map((data) => {
                filteredObservations.push(data);
              });
            }

            const postData = {
              prescription: {
                HIP: hip,
                careContextId: selectedContext,
                start_date: currentDate,
                end_date: currentDate,
                patientId: state?.patientData.patient_id,
                fileName: "Prescription.pdf",
                fileContent: prescriptionBase64.split(";base64,").pop(),
                medications: medications,
                practitioner: state?.doctorData.name,
                practitionerID: state?.doctorData.doctor_id,
              },
            };

            const opObservations = filteredObservations.map((obs) => {
              console.log("obs.observation_date", obs.observation_date);
              return {
                resource_type: "Observation",
                observation_code: obs.observation_code,
                observation_description: obs.observation_description,
                value_quantity: obs.value_quantity,
                value_string: obs.value_string,
                value_boolean: obs.value_boolean,
                value_codeable_concept: obs.value_codeable_concept,
                observation_date: obs.observation_date
                  ? obs.observation_date
                  : null,
                unit_code: obs.unit_code,
                unit: obs.unit,
                note: obs.note,
              };
            });

            // const opObservations = [
            //   ...filteredObservations.map((obs) => ({
            //     resource_type: "Observation",
            //     observation_code: obs.observation_code,
            //     observation_description: obs.observation_description,
            //     value_quantity: obs.value_quantity,
            //     value_string: obs.value_string,
            //     value_boolean: obs.value_boolean,
            //     value_codeable_concept: obs.value_codeable_concept,
            //     observation_date: obs.observation_date
            //       ? obs.observation_date
            //       : null,
            //     unit_code: obs.unit_code,
            //     unit: obs.unit,
            //     note: obs.note,
            //   })),

            //   //Conditionally add observation(advice) only if MedicalAdvice.advice exists and is not empty
            //   ...(selectedSectionsData["MedicalAdvice"]?.advice?.trim()
            //     ? [
            //         {
            //           resource_type: "Observation",
            //           observation_description:
            //             selectedSectionsData["MedicalAdvice"]?.advice.trim(),
            //           observation_code: null,
            //           value_quantity: null,
            //           value_string: null,
            //           value_boolean: null,
            //           value_codeable_concept: null,
            //           observation_date: null,
            //           unit_code: null,
            //           unit: null,
            //           note: null,
            //         },
            //       ]
            //     : []),
            // ];

            const OtherObservationsForAdvice = [
              // Conditionally add medical advice to a separate array
              ...(selectedSectionsData["MedicalAdvice"]?.advice?.trim()
                ? [
                    {
                      resource_type: "OtherObservation",
                      observation_description: "Medical Advice",
                      observation_code: null,
                      value_quantity: null,
                      value_string:
                        selectedSectionsData["MedicalAdvice"]?.advice.trim(),
                      value_boolean: null,
                      value_codeable_concept: null,
                      observation_date: null,
                      unit_code: null,
                      unit: null,
                      note: null,
                    },
                  ]
                : []),
            ];

            const opDentalData = dentalData.flatMap((item) => {
              const idString = item.id;

              // Check if the ID represents a quadrant or jaw (contains parentheses)
              if (idString.includes("(") && idString.includes(")")) {
                return {
                  resource_type: "DentalObservation",
                  observation_code: null,
                  observation_description: `FDI Teeth Set: ${idString.replace(
                    /_/g,
                    "",
                  )}`, // Remove underscores
                  value_quantity: null,
                  value_string: item.clinical_note,
                  value_boolean: null,
                  value_codeable_concept: null,
                  observation_date: formatDateYYYYMMDD(
                    state?.dateForAppointment?.toISOString(),
                  ),
                  unit_code: null,
                  unit: null,
                  note: null,
                };
              }

              // If it's individual teeth numbers, split and create separate objects
              return idString.split(", ").map((id) => ({
                resource_type: "DentalObservation",
                observation_code: null,
                observation_description: `FDI Teeth No. ${id.replace("_", "")}`,
                value_quantity: null,
                value_string: item.clinical_note,
                value_boolean: null,
                value_codeable_concept: null,
                observation_date: formatDateYYYYMMDD(
                  state?.dateForAppointment?.toISOString(),
                ),
                unit_code: null,
                unit: null,
                note: null,
              }));
            });
            const getInitialObservationPayload = () => {
              const observationDate = state?.dateForAppointment
                ?.toISOString()
                .split("T")[0];
              const panelData = filterInitialObservationForClinicalPayload(
                selectedSectionsData["InitialObservation"] || [],
              );

              return panelData.map((panel) => {
                const child_observations = panel.tests
                  // Only include tests where trimmed value is not empty
                  .filter((test) => test.value && test.value.trim().length > 0)
                  .map((test) => {
                    const parsedValue = parseFloat(test.value);
                    const isNumeric = !isNaN(parsedValue);

                    return {
                      resource_type: "ClinicalTestObservation",
                      observation_code: test.code || null,
                      observation_date: observationDate,
                      observation_description: test.test,
                      unit: test.unit || null,
                      unit_code: null,
                      value_quantity: isNumeric ? parsedValue : null,
                      value_string: isNumeric ? null : test.value || null,
                      value_boolean: null,
                      value_codeable_concept: null,
                    };
                  });

                return {
                  resource_type: "ClinicalObservation",
                  observation_date: observationDate,
                  observation_description: panel.panel_name,
                  observation_code: null,
                  unit: null,
                  unit_code: null,
                  value_quantity: null,
                  value_string: `${panel.panel_name} test results`,
                  value_boolean: null,
                  value_codeable_concept: null,
                  child_observations,
                };
              });
            };

            console.log("Op Observations", opObservations);
            console.log("Filtered Observations", filteredObservations);
            const wellnessPostData = {
              HIP: hip,
              file_data: [
                {
                  HIPID: hip,
                  patientID: state?.patientData.patient_id,
                  start_date: currentDate,
                  end_date: currentDate,
                  careContextID: selectedContext,
                  rptDateTime: currentDate,
                  practitioner: state?.doctorData.name,
                  practitionerID: state?.doctorData.doctor_id,
                  document: "Wellness",
                  detail: [...filteredObservations],
                  attachment: [
                    {
                      type: "application/pdf",
                      data: wellnessBase64.split(";base64,").pop(),
                      name: `Wellness_${uuidv4().slice(0, 7)}.pdf`,
                    },
                  ],
                },
              ],
            };

            const op_consultation = {
              HIP: hip,
              file_data: [
                {
                  careContextID: selectedContext,
                  patientID: state?.patientData.patient_id,
                  date: currentDate,
                  encounterStartDate: currentDate,
                  encounterEndDate: currentDate,
                  practitioner: state?.doctorData.name,
                  practitionerID: state?.doctorData.doctor_id,
                  detail: [
                    chiefComplaintsObject, //encounter
                    ...opConditionsChiefComplaints, //condition
                    ...opTestsAndInvestigations, //test and investigation
                    ...opObservations, //observations
                    ...opMedications, //Medications
                    ...opProcedures, //Procedures
                    ...opDentalData, //Observations For Dental
                    ...OtherObservationsForAdvice, //Observations For Medical Advice
                    ...getInitialObservationPayload(),
                  ],
                  attachments: [...opAttachments],
                },
              ],
            };

            console.log(
              "IPD Admission Referral1",
              selectedSectionsData["IPDAdmissionReferral"],
              Object.keys(ipdReferralError).length,
            );
            if (
              (selectedSectionsData["IPDAdmissionReferral"] || []).length > 0 &&
              Object.keys(ipdReferralError).length == 0
            ) {
              let ipdAdmissionReferral = {
                category: null,
                category_code: null,
                practitioner_id:
                  selectedSectionsData["IPDAdmissionReferral"][0]
                    ?.doctor_details?.doctor_id ?? null,
                practitioner_name:
                  selectedSectionsData["IPDAdmissionReferral"][0]
                    ?.doctor_details?.name ?? null,
                recorded_date: state?.dateForAppointment?.toISOString(),
                resource_type: "Referral",
                service_code: null,
                service_description: selectedSectionsData[
                  "IPDAdmissionReferral"
                ][0]?.admission_details
                  ? `Admission Details: ${selectedSectionsData["IPDAdmissionReferral"][0]?.admission_details}, Admission Type: ${selectedSectionsData["IPDAdmissionReferral"][0]?.admission_type}, Expected Date: ${selectedSectionsData["IPDAdmissionReferral"][0]?.expected_date}`
                  : "",
              };
              console.log("IPD Admission Referral", ipdAdmissionReferral);
              op_consultation.file_data[0].detail.push(ipdAdmissionReferral);
            }

            console.log(
              "Op Referral1",
              selectedSectionsData["Referral"],
              Object.keys(referralError).length,
            );
            if (
              selectedSectionsData["Referral"].length > 0 &&
              Object.keys(referralError).length == 0
            ) {
              let opReferral = {
                category: null,
                category_code: null,
                practitioner_id:
                  selectedSectionsData["Referral"][0]?.doctor_details
                    ?.doctor_id ?? null,
                practitioner_name:
                  selectedSectionsData["Referral"][0]?.doctor_details?.name ??
                  null,
                recorded_date: state?.dateForAppointment?.toISOString(), //current date
                resource_type: "Referral",
                service_code: null,
                service_description:
                  selectedSectionsData["Referral"][0]?.service_description ??
                  "",
              };
              console.log("Op Referral", opReferral);
              op_consultation.file_data[0].detail.push(opReferral);
            }
            console.log(
              "Op Follow up1",
              selectedSectionsData["FollowUp"],
              Object.keys(followUpError).length,
            );
            if (
              selectedSectionsData["FollowUp"].length > 0 &&
              Object.keys(followUpError).length == 0
            ) {
              let opFollowUp = {
                appointment_type: "Follow-up visit",
                creation_date: null,
                end_date: null,
                practitioner_id: state?.doctorData.doctor_id,
                practitioner_name: state?.doctorData.name,
                reason: null,
                resource_type: "Appointment",
                service_category: state?.doctorData.department,
                service_type:
                  selectedSectionsData["FollowUp"][0]?.service_type ?? "",
                specialty: null,
                start_date:
                  selectedSectionsData["FollowUp"][0]?.start_date ?? "",
              };
              console.log("Op Follow Up", opFollowUp);
              op_consultation.file_data[0].detail.push(opFollowUp);
            }
            const proceduresForLabTest = selectedSectionsData["Procedures"]
              .filter((p) => p.source === "database")
              .map((p) => ({
                name: p.term,
                code: p.id,
                medical_service_id: p.medical_service_id,
              }));
            const examinationsForLabTest = testsAndInvestigations
              .filter((e) => e.source === "database")
              .map((e) => ({
                name: e.term,
                code: e.id,
                medical_service_id: e.medical_service_id,
              }));
            const testsForLabPostBody = [
              ...examinationsForLabTest,
              ...proceduresForLabTest,
            ];

            const patientLabTestdata = {
              appointment_id: state?.appointmentId,
              care_context_id: selectedContext,
              test: testsForLabPostBody,
            };
            const medicinesForPharmacy = opMedications.map((med) => ({
              name: med.drug_name,
              code: med.medication_id,
            }));
            const patientMedicinedata = {
              appointment_id: state?.appointmentId,
              care_context_id: selectedContext,
              medicine: medicinesForPharmacy,
              status: "NEW",
              doctor_name: "",
            };
            if (familyHistory.family_member_details.length > 0) {
              op_consultation.file_data[0].detail.push(familyHistory);
            }
            if (allergyHistory.allergy_details.length > 0) {
              op_consultation.file_data[0].detail.push(allergyHistory);
            }
            if (medicalHistoryData.length > 0) {
              op_consultation.file_data[0].detail.push(...medicalHistoryData);
            }
            if (presentIllnessData.length > 0) {
              op_consultation.file_data[0].detail.push(...presentIllnessData);
            }
            if (drugHistoryData.length > 0) {
              op_consultation.file_data[0].detail.push(...drugHistoryData);
            }
            if (surgicalHistoryData.length > 0) {
              op_consultation.file_data[0].detail.push(...surgicalHistoryData);
            }

            const emailSubmitPostData = {
              ATTACHMENT: [
                {
                  FILE: wellnessBase64.split(";base64,").pop(),
                  FILENAME: "Wellness.pdf",
                },
                {
                  FILE: prescriptionBase64.split(";base64,").pop(),
                  FILENAME: "Prescription.pdf",
                },
                ...opAttachmentsEmails,
              ],

              RECIPIENT: state?.patientData.email,
              SENDER: REACT_APP_SENDER_EMAIL,
              SUBJECT: "Op Consultation Attachments",
              TYPE: "INVOICE",
            };
            console.log("Prescription Post Data", postData);
            console.log("Op Post Data", op_consultation);
            console.log("Wellness Post Data", wellnessPostData);
            console.log("Email Submit Post Data", emailSubmitPostData);
            console.log("Patient Lab Test Post Data", patientLabTestdata);
            console.log("Patient Medicines Post Data", patientLabTestdata);

            let fhirPostBody = {
              //create real time prescription fhir end point ,check if medicines present or not
              prescription:
                postData.prescription.medications.length > 0
                  ? postData.prescription
                  : null,
              //create realtime op fhir ,check if details length > 1 or not (As Encounter will always be present or attachments.length>0 or not)
              op_consultation:
                op_consultation.file_data[0].attachments.length > 0 ||
                op_consultation.file_data[0].detail.length > 1
                  ? op_consultation
                  : null,
              //create real time wellness fhir
              wellness_record:
                filteredObservations.length > 0 ? wellnessPostData : null,
            };
            console.log("fhirPostBody", fhirPostBody);
            axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}op_consultation_submission/`,
                fhirPostBody,
                {
                  headers: headers,
                },
              )
              .then((response) => {
                console.log("Add Fhir Log", response.data);
              })
              .catch((err) => {
                console.log(err);
              });

            //medical background post body for storing newly added history of patient
            const medicalBackgroundPostBody = {
              patient_id: state?.patientData.patient_id,
              care_context_id: selectedContext,
              date: formatDateYYYYMMDD(currentDate),
              family_history:
                familyHistoryNewData.length > 0 ? familyHistoryNewData : [],
              medical_history:
                medicalHistoryNewData.length > 0 ? medicalHistoryNewData : [],
              surgical_history:
                surgicalHistoryNewData.length > 0 ? surgicalHistoryNewData : [],
              allergy_history:
                allergyHistoryNewData.length > 0 ? allergyHistoryNewData : [],
              addiction_history:
                addictionHistoryNewData.length > 0
                  ? addictionHistoryNewData
                  : [],
              drug_history:
                drugHistoryNewData.length > 0 ? drugHistoryNewData : [],
              menstrual_history:
                menstrualHistoryNewData.length > 0
                  ? menstrualHistoryNewData
                  : [],
              immunization_history:
                adultVaccinationNewData.length > 0
                  ? adultVaccinationNewData
                  : [],
            };
            if (isNewHistoryDataPresent) {
              axios
                .post(
                  `${REACT_APP_BACKEND_ROUTE_URL}add_patient_history/`,
                  medicalBackgroundPostBody,
                  {
                    headers: headers,
                  },
                )
                .then((response) => {
                  console.log("Add History Log", response.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            // sending mail
            if (sessionStorage.getItem("isEmailEnabled") !== "true") {
              // toast.error("Email service not activated for this license");
              // showAlertDialog("Email service not activated for this license");
              toast(
                ({ closeToast }) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      fontFamily: "Segoe UI, sans-serif",
                    }}
                  >
                    <div style={{ fontWeight: 500 }}>
                      Email service not activated for this license.
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <button
                        onClick={() => {
                          closeToast();
                        }}
                        style={{
                          padding: "6px 16px",
                          backgroundColor: "#007bff",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                          fontSize: "14px",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                ),
                {
                  autoClose: false,
                  closeOnClick: false,
                  closeButton: false,
                  icon: false,
                },
              );
            } else if (
              !state?.patientData?.email ||
              typeof state.patientData.email !== "string" ||
              state.patientData.email.trim() === ""
            ) {
              // toast.error(
              //   "Email not sent as patient's email address is unavailable"
              // );
              // showAlertDialog(
              //   "Patient’s profile doesn’t have email address. The system is unable to send email."
              // );
              toast(
                ({ closeToast }) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      fontFamily: "Segoe UI, sans-serif",
                    }}
                  >
                    <div style={{ fontWeight: 500 }}>
                      Patient’s profile doesn’t have email address. The system
                      is unable to send email.
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <button
                        onClick={() => {
                          closeToast();
                        }}
                        style={{
                          padding: "6px 16px",
                          backgroundColor: "#007bff",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                          fontSize: "14px",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                ),
                {
                  autoClose: false,
                  closeOnClick: false,
                  closeButton: false,
                  icon: false,
                },
              );
            } else {
              axios
                .post(
                  `${REACT_APP_BACKEND_ROUTE_URL}send_email/`,
                  emailSubmitPostData,
                  {
                    headers: headers,
                  },
                )
                .then((response) => {
                  console.log("Email Submit Log", response.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            //sending message to the patient who has no abha id
            if (isAbdmEnabled && !state?.patientData.abha_id) {
              const messagePostBody = {
                hip: {
                  id: hip,
                  name: hip,
                },
                phoneNo: state?.patientData.phone_no,
              };
              axios
                .post(
                  `${REACT_APP_BACKEND_ROUTE_URL}new_health_record_notification_for_existing_care_context_sms_endpoint/`,
                  messagePostBody,
                  {
                    headers: headers,
                  },
                )
                .then((response) => {
                  console.log("Message Submit Log", response.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            if (testsForLabPostBody.length > 0) {
              axios
                .post(
                  `${REACT_APP_BACKEND_ROUTE_URL}add_patient_lab_tests/`,
                  patientLabTestdata,
                  {
                    headers: headers,
                  },
                )
                .then((response) => {
                  console.log("Patient Lab Test Submit Log", response.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            if (opMedications.length > 0) {
              console.log("pharmacyMedications", pharmacyMedications);
              console.log("Diagnosis", selectedSectionsData["Diagnosis"]);
              console.log(
                "chiefComplaints",
                selectedSectionsData["Chief Complaints"],
              );
              const payload = {
                patient_id: state?.patientData.patient_id,
                care_context_id: selectedContext,
                practitioner_id: state?.doctorData.doctor_id,
                practitioner_name: state?.doctorData.name,
                medications: pharmacyMedications,
                diagnosis: selectedSectionsData["Diagnosis"]
                  .map((item) => item.term)
                  .join(", "),

                chief_complaints: selectedSectionsData["Chief Complaints"]
                  .map((item) => item.condition)
                  .join(", "),
                clinical_notes: "-",
              };

              axios
                .post(
                  `${REACT_APP_BACKEND_ROUTE_URL}add_patient_prescription/`,
                  payload,
                  {
                    headers: headers,
                  },
                )
                .then((res) => {});
            }

            // Check if any medicines have source "custom" and call add_medicine API
            if (opMedications.length > 0) {
              const customMedicines = selectedSectionsData[
                "Medications"
              ].filter((medicine) => medicine.source === "custom");

              if (customMedicines.length > 0) {
                const customMedicineTerms = customMedicines.map(
                  (medicine) => medicine.term,
                );

                axios
                  .post(
                    `${REACT_APP_BACKEND_ROUTE_URL}add_medicine/`,
                    { terms: customMedicineTerms },
                    {
                      headers: headers,
                    },
                  )
                  .then((addMedicineRes) => {
                    console.log("Custom medicines added", addMedicineRes.data);
                  })
                  .catch((err) => {
                    console.log("Error adding custom medicines", err);
                  });
              }
            }

            // Check if any service have source "custom" and call bulk_add_medical_service API

            // Collect custom services from both sections
            let allCustomTerms = [];

            // From Tests/Investigations
            if (
              opTestsAndInvestigations.length > 0 &&
              selectedSectionsData["Tests/Investigations"]
            ) {
              const testCustomTerms = selectedSectionsData[
                "Tests/Investigations"
              ]
                .filter((service) => service.source === "custom")
                .map((service) => service.term);

              allCustomTerms = [...allCustomTerms, ...testCustomTerms];
            }

            // From Procedures
            if (opProcedures.length > 0 && selectedSectionsData["Procedures"]) {
              const procedureCustomTerms = selectedSectionsData["Procedures"]
                .filter((service) => service.source === "custom")
                .map((service) => service.term);

              allCustomTerms = [...allCustomTerms, ...procedureCustomTerms];
            }

            // Remove duplicates using Set
            const uniqueCustomTerms = [...new Set(allCustomTerms)];

            // Call API only once if there are unique custom terms
            if (uniqueCustomTerms.length > 0) {
              const hip = sessionStorage.getItem("facility_name");
              axios
                .post(
                  `${REACT_APP_BACKEND_ROUTE_URL}bulk_add_medical_service/`,
                  { terms: uniqueCustomTerms, facility_id: hip },
                  { headers },
                )
                .then((res) => {
                  console.log("Custom Services added", res.data);
                })
                .catch((err) => {
                  console.log("Error adding custom services", err);
                });
            }

            // Check if any vaccine have source "custom" and call add_vaccine API
            if (selectedSectionsData["Adult Vaccination"]) {
              const customVaccines = selectedSectionsData["Adult Vaccination"]
                .filter((vaccine) => vaccine.source === "custom")
                .map((vaccine) => vaccine.vaccine_name);

              const uniqueCustomVaccines = [...new Set(customVaccines)];

              if (uniqueCustomVaccines.length > 0) {
                axios
                  .post(
                    `${REACT_APP_BACKEND_ROUTE_URL}add_vaccine/`,
                    { terms: uniqueCustomVaccines },
                    { headers: headers },
                  )
                  .then((res) => {
                    console.log("Custom Vaccines added", res.data);
                  })
                  .catch((err) => {
                    console.log("Error adding custom vaccines", err);
                  });
              }
            }

            const ipdAdmissionReferralData =
              selectedSectionsData?.["IPDAdmissionReferral"];
            if (
              Array.isArray(ipdAdmissionReferralData) &&
              ipdAdmissionReferralData.length > 0 &&
              ipdAdmissionReferralData?.[0]?.admission_details
            ) {
              const ipd0 = ipdAdmissionReferralData[0];
              const ipdQueuePayload = {
                patient_id: state?.patientData.patient_id,
                admission_details: ipd0.admission_details,
                admission_type: ipd0.admission_type,
                expected_date: ipd0.expected_date
                  ? dayjs(ipd0.expected_date).format("YYYY-MM-DD")
                  : null,
                referred_doctor:
                  ipd0?.doctor_details?.name ||
                  ipd0?.doctor_details ||
                  state?.doctorData?.name,
                referred_doctor_id:
                  ipd0?.doctor_details?.doctor_id ??
                  state?.doctorData?.doctor_id,
              };

              axios
                .post(
                  `${REACT_APP_BACKEND_ROUTE_URL}ipd_queue/`,
                  ipdQueuePayload,
                  { headers },
                )
                .then((res) => {
                  console.log("IPD Queue added", res.data);
                })
                .catch((err) => {
                  console.log("Error adding to IPD Queue", err);
                });
            }

            //Delete the history section of the case sheet
            axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}create_patient_diabetic_profile/`,
                {
                  patient_id: state?.patientData.patient_id,
                  medical_history: [],
                  history_of_present_illness: [],
                  family_history: [],
                  drug_history: [],
                  allergies: [],
                  addiction_history: [],
                  surgeries_history: [],
                  vaccination_history: [],
                  menstrual_history: [],
                  chief_complaints: [],
                },
                {
                  headers: headers,
                },
              )
              .then((res) => {});

            return pastVisitPromise;
          },
        )
        .then((response) => {
          console.log("Past Visit Submit Log", response.data);
          // if (response.data.message === "Past visit added!") {
          //   console.log("State in if block", state);
          //   fetchPastVisits(state?.patientData);
          // }
          const careContext = care_context_list.find(
            (cc) => cc.care_context_reference === selectedContext,
          );
          if (
            !careContext.abdm_linked &&
            state?.patientData.abha_id &&
            abdmInterperabilityToggle
          ) {
            var postBody = {
              add_context: {
                link: {
                  patient: {
                    careContexts: [
                      {
                        display: selectedContextDisplay,
                        referenceNumber: selectedContext,
                      },
                    ],
                    display: state?.patientData.abha_id,
                    referenceNumber: state?.patientData.patient_id,
                  },
                },
              },
              auth_confirm: {
                credential: {
                  demographic: {
                    authCode: "",
                    dateOfBirth: state?.patientData?.dob,
                    gender: state?.patientData?.gender?.substring(0, 1) || "",
                    name: state?.patientData?.name,
                  },
                },
              },
              auth_init: {
                query: {
                  authMode: "DEMOGRAPHICS",
                  id: state?.patientData.abha_id,
                  purpose: "KYC_AND_LINK",
                  requester: {
                    id: facility_id,
                    type: "HIP",
                  },
                },
              },
            };

            // Returned so the outer chain (and the Submit button's loading state)
            // waits for the ABDM link call to settle.
            return axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}auth_init_workflow_new/`,
                JSON.stringify(postBody),
                {
                  headers: headers,
                },
              )
              .then((res) => {
                if (res.data.status !== "") {
                  // console.log(res);
                  if (res.data.status === "Success" || "success") {
                    setOpConsultationSubmited(true);
                    toast.success("OP Consultation Submitted Successfully");
                    draftAutosaveDisabledAfterSubmitRef.current = true;
                    clearDoctorConsoleDraft(); // Local IndexedDB
                    deleteServerPrescriptionDraftAfterSubmit(); // DELETE prescription_draft/

                    //Getting the history data after submission of the e-prescription
                    // handleGetPatientHistoryData();
                  }
                }
              })
              .catch((err) => {
                console.log(err);
                toast.error(err);
                //ChangeCursor();
              });
          } else {
            toast.success("OP Consultation Submitted Successfully");
            setOpConsultationSubmited(true);
            draftAutosaveDisabledAfterSubmitRef.current = true;
            clearDoctorConsoleDraft(); // Local IndexedDB
            deleteServerPrescriptionDraftAfterSubmit(); // DELETE prescription_draft/
            //Getting the history data after submission of the e-prescription
            // handleGetPatientHistoryData();
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong.Please try again later.");
        });
    } else {
      toast.error("Please add a Visit Purpose!");
    }
  };
  const waitForElementImages = (inputElement, timeoutMs = 500) =>
    Promise.all(
      Array.from(inputElement.querySelectorAll("img")).map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) {
              resolve();
              return;
            }
            const done = () => resolve();
            img.addEventListener("load", done, { once: true });
            img.addEventListener("error", done, { once: true });
            setTimeout(done, timeoutMs);
          }),
      ),
    );

  const generatePdfBase64 = (inputElement, fileName) => {
    if (!inputElement) {
      return Promise.reject(new Error("Missing element for PDF generation"));
    }

    return waitForElementImages(inputElement).then(() =>
      html2canvas(inputElement, {
        useCORS: true,
        allowTaint: true,
        scrollY: 0,
        // Default is 15s per image; broken <img> nodes can stall submit.
        imageTimeout: 500,
        onclone: (_clonedDoc, element) => {
          element.querySelectorAll("img").forEach((img) => {
            const src = img.getAttribute("src");
            if (!src || !img.complete || img.naturalWidth === 0) {
              img.remove();
            }
          });
        },
      })
        .then((canvas) => {
          const image = { type: "jpeg", quality: 0.98 };
          const margin = [0.5, 0.5];

          var imgWidth = 8.5;
          var pageHeight = 11;

          var innerPageWidth = imgWidth - margin[0] * 2;
          var innerPageHeight = pageHeight - margin[1] * 2;

          var pxFullHeight = canvas.height;
          var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
          var nPages = Math.ceil(pxFullHeight / pxPageHeight);

          var pageHeight = innerPageHeight;

          var pageCanvas = document.createElement("canvas");
          var pageCtx = pageCanvas.getContext("2d");
          pageCanvas.width = canvas.width;
          pageCanvas.height = pxPageHeight;

          var pdf = new jsPDF("p", "in", [8.5, 11]);

          for (var page = 0; page < nPages; page++) {
            if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
              pageCanvas.height = pxFullHeight % pxPageHeight;
              pageHeight =
                (pageCanvas.height * innerPageWidth) / pageCanvas.width;
            }

            var w = pageCanvas.width;
            var h = pageCanvas.height;
            pageCtx.fillStyle = "white";
            pageCtx.fillRect(0, 0, w, h);
            pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

            if (page > 0) pdf.addPage();
            var imgData = pageCanvas.toDataURL(
              "image/" + image.type,
              image.quality,
            );
            pdf.addImage(
              imgData,
              image.type,
              margin[1],
              margin[0],
              innerPageWidth,
              pageHeight,
            );
          }

          // if (
          //   fileName == "Prescription.pdf" ||
          //   fileName == "Op Consultation.pdf" ||
          //   fileName == "Wellness.pdf"
          // ) {
          //   pdf.save(fileName);
          // }

          return pdf.output("datauristring");
        })
        .catch((err) => {
          console.log(err);
        }),
    );
  };
  const handleTimelineData = (data) => {
    setTimelineData(data);
  };
  const handleTimelineDataAbdm = (data) => {
    setTimelineDataAbdm(data);
  };

  const handleFhirArray = (fhirArray) => {
    console.log("Setting s3Bucket fhir", fhirArray);
    setS3BucketFhir(fhirArray);
  };

  const updateSectionData = (type, data) => {
    setSelectedSectionsData((prevData) => ({
      ...prevData,
      [type]: data,
    }));
  };

  console.log("Doctor console Suggestions", suggestions);
  console.log("Selected Sections Data", selectedSectionsData);

  const configStores = {
    selectedSectionsData,
    medicalBackground,
    vitals,
    dentalData,
    bloodGroup,
    otherExaminations,
  };

  const featureFlags = useMemo(
    () => ({
      caseSheet: isConsoleFeatureEnabled("caseSheet"),
      patient360: isConsoleFeatureEnabled("patient360"),
      voicePrescription: isConsoleFeatureEnabled("voicePrescription"),
      transcription: isConsoleFeatureEnabled("transcription"),
      telemedicine: isConsoleFeatureEnabled("telemedicine"),
    }),
    [isConsoleFeatureEnabled],
  );

  // The action buttons share a single 12-column row, so the span has to follow
  // how many of them are enabled - otherwise a disabled feature leaves an empty
  // gap at the end of the row.
  const actionButtonSpan = useMemo(() => {
    const enabledCount = [
      featureFlags.caseSheet,
      featureFlags.patient360,
      featureFlags.telemedicine,
      featureFlags.voicePrescription,
    ].filter(Boolean).length;
    return enabledCount > 0 ? 12 / enabledCount : 12;
  }, [
    featureFlags.caseSheet,
    featureFlags.patient360,
    featureFlags.telemedicine,
    featureFlags.voicePrescription,
  ]);

  useEffect(() => {
    if (!featureFlags.voicePrescription && openMicModal) {
      setOpenMicModal(false);
    }
  }, [featureFlags.voicePrescription, openMicModal]);

  useEffect(() => {
    if (!featureFlags.transcription && voiceTranscripton) {
      setVoiceTransciption(false);
    }
  }, [featureFlags.transcription, voiceTranscripton]);

  useEffect(() => {
    if (!featureFlags.telemedicine && showTelePanel) {
      setShowTelePanel(false);
    }
  }, [featureFlags.telemedicine, showTelePanel]);

  return (
    <DoctorConsoleConfigProvider
      config={remoteConsoleConfig}
      patient={state?.patientData}
      permissions={{ isAiEnabled }}
      appointment={{ dateForAppointment: state?.dateForAppointment }}
      doctor={state?.doctorData}
      stores={configStores}
    >
      <ThemeProvider theme={theme}>
        <AlertDialog
          open={showAlert}
          message={alertMessage}
          onClose={() => setShowAlert(false)}
        />

        <DoctorconsoleGrid
          container
          spacing={2}
          sx={{ padding: "5px 10px", justifyContent: "center", marginLeft: 0 }}
          backgroundColor="white"
          color="white"
        >
          <Card sx={styles.card}>
            {(featureFlags.caseSheet ||
              featureFlags.patient360 ||
              featureFlags.voicePrescription ||
              featureFlags.telemedicine) && (
              <DoctorconsoleGrid container spacing={2} sx={{ mb: 1.5 }}>
                {featureFlags.caseSheet && (
                  <DoctorconsoleGrid
                    item
                    xs={12}
                    sm={actionButtonSpan}
                    md={actionButtonSpan}
                  >
                    <StyledButton
                      disabled={!state?.patientData?.patient_id}
                      bgColor="#0E3F66"
                      onClick={() => setIsCaseSheetOpen(true)}
                      variant="contained"
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "1rem" },
                        width: "100%",
                        gap: 2,
                        height: "34px",
                      }}
                    >
                      Case Sheet
                      <span sx={{ marginLeft: 1 }}>
                        <DescriptionOutlinedIcon
                          sx={{ color: "#fff", fontSize: 24 }}
                          aria-hidden
                        />
                      </span>
                    </StyledButton>
                  </DoctorconsoleGrid>
                )}
                {featureFlags.patient360 && (
                  <DoctorconsoleGrid
                    item
                    xs={12}
                    sm={actionButtonSpan}
                    md={actionButtonSpan}
                  >
                    <StyledButton
                      bgColor="#0E3F66"
                      onClick={handleOpenPatientSummaryModal}
                      variant="contained"
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "1rem" },
                        width: "100%",
                        gap: 2,
                        height: "34px",
                      }}
                    >
                      Patient 360
                      <span sx={{ marginLeft: 1 }}>
                        <Icon name="patient360Icon" size={24} />
                      </span>
                    </StyledButton>
                  </DoctorconsoleGrid>
                )}
                {featureFlags.telemedicine && (
                  <DoctorconsoleGrid
                    item
                    xs={12}
                    sm={actionButtonSpan}
                    md={actionButtonSpan}
                  >
                    <StyledButton
                      bgColor="#0E3F66"
                      onClick={() => setShowTelePanel((prev) => !prev)}
                      variant="contained"
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "1rem" },
                        width: "100%",
                        gap: 2,
                        height: "34px",
                      }}
                    >
                      Telemedicine
                      <span sx={{ marginLeft: 1 }}>
                        <VideoCallIcon sx={{ fontSize: 22, color: "#fff" }} />
                      </span>
                    </StyledButton>
                  </DoctorconsoleGrid>
                )}
                {featureFlags.voicePrescription && (
                  <DoctorconsoleGrid
                    item
                    xs={12}
                    sm={actionButtonSpan}
                    md={actionButtonSpan}
                  >
                    <StyledButton
                      bgColor="#0E3F66"
                      onClick={handleOpenMicModal}
                      variant="contained"
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "1rem" },
                        width: "100%",
                        gap: 2,
                        height: "34px",
                      }}
                    >
                      Voice Prescription
                      <span sx={{ marginLeft: 1 }}>
                        <Icon name="voicePrescriptionIcon" size={26} />
                      </span>
                    </StyledButton>
                  </DoctorconsoleGrid>
                )}
              </DoctorconsoleGrid>
            )}
            <Grid item xs={12}>
              <DoctorconsoleHeader
                patient={state?.patientData}
                selectedContext={selectedContext}
                setSelectedContext={setSelectedContext}
                setSelectedContextDisplay={setSelectedContextDisplay}
                care_context_list={care_context_list}
                setAddCareContextModalOpen={setAddCareContextModalOpen}
              />
            </Grid>

            <DoctorconsoleGrid
              container
              spacing={1}
              sx={{
                justifyContent: "flex-end",
                alignItems: "center",
                mt: "4px",
              }}
            >
              <DoctorconsoleGrid item sm={6} md={2}></DoctorconsoleGrid>
              <DoctorconsoleGrid item sm={6} md={4} lg={4} xl={4}>
                {/* Patient's Timeline (commented temporarily) */}
                {/* <DoctorconsoleGrid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "30px",
              }}
            >
              <Fab
                sx={{
                  position: "relative",
                  color: "#fff",
                  backgroundColor: "#21cdc0",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "-100%",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#26365e",
                    zIndex: -1,
                    transition: "left 0.1s ease-in-out",
                  },
                  "&:hover::before": {
                    left: 0,
                  },

                  textTransform: "none",
                }}
                aria-label="add"
                onClick={handleTimelineDrawerToggle}
                variant="extended"
              >
                {!timelineDrawerOpen ? (
                  <ArrowDownwardIcon />
                ) : (
                  <ArrowUpwardIcon />
                )}
                Patient's Timeline
              </Fab>
            </DoctorconsoleGrid> */}
              </DoctorconsoleGrid>
              <DoctorconsoleGrid item sm={12} md={6} lg={5} xl={4}>
                <DoctorconsoleGrid
                  container
                  spacing={1.5}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: { xs: "space-evenly", md: "flex-end" },
                  }}
                >
                  {/* ABDM Interoperability */}
                  <SwitchWithLabel
                    id="abdmInterperability"
                    label="ABDM Interoperability"
                    checked={!isAbdmEnabled ? false : abdmInterperabilityToggle}
                    disabled={!isAbdmEnabled}
                    onChange={() =>
                      setAbdmInterperabilityToggle(!abdmInterperabilityToggle)
                    }
                    variant="blueGreen"
                  />

                  {/* Rule Driven Suggestions */}
                  <SwitchWithLabel
                    id="sectionToggle"
                    label="Rule Driven Suggestions"
                    checked={ruleSuggestionToggle}
                    onChange={() =>
                      setRuleSuggestionToggle(!ruleSuggestionToggle)
                    }
                    // color="success"
                    variant="green"
                  />

                  {/* AI Suggestions */}
                  <SwitchWithLabel
                    id="aiSuggestionToggle"
                    label="AI Suggestions"
                    checked={!isAiEnabled ? false : aiSuggestionToggle}
                    disabled={!isAiEnabled}
                    onChange={() => setAiSuggestionToggle(!aiSuggestionToggle)}
                    // color="secondary"
                    variant="purple"
                  />
                </DoctorconsoleGrid>
              </DoctorconsoleGrid>
              {/* <DoctorconsoleGrid item sm={6} md={2}>
              <StyledButton
                bgColor="#0E3F66"
                onClick={() => {
                  setOpenPastRecordsModal(true);
                }}
                variant="contained"
                sx={{
                  fontSize: { xs: "0.8rem", sm: "1rem" },
                  width: "100%",
                }}
              >
                Past Records
              </StyledButton>
            </DoctorconsoleGrid> */}
            </DoctorconsoleGrid>

            {/* Patient's Timeline */}
            {/* <DoctorconsoleGrid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "30px",
          }}
        >
          <Fab
            sx={{
              position: "relative",
              color: "#fff",
              backgroundColor: "#21cdc0",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                backgroundColor: "#26365e",
                zIndex: -1,
                transition: "left 0.1s ease-in-out",
              },
              "&:hover::before": {
                left: 0,
              },

              textTransform: "none",
            }}
            aria-label="add"
            onClick={handleTimelineDrawerToggle}
            variant="extended"
          >
            {!timelineDrawerOpen ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
            Patient's Timeline
          </Fab>
        </DoctorconsoleGrid> */}

            {/* {timelineDrawerOpen && (
          <DoctorconsoleGrid container spacing={2}>
            <DoctorconsoleGrid item xs={12}>
              <TimelineMain
                careContextList={care_context_list}
                organizedArray={abdmData}
                timelineData={timelineData}
                timelineDataAbdm={timelineDataAbdm}
                handleTimelineData={handleTimelineData}
                handleTimelineDataAbdm={handleTimelineDataAbdm}
                patientData={state?.patientData}
              />
            </DoctorconsoleGrid>
            <DoctorconsoleGrid item xs={12}>
              <Button
                variant="contained"
                color="defaultColor"
                sx={{ width: "100%" }}
                onClick={handleTimelineDrawerClose}
              >
                <ArrowUpwardIcon />
              </Button>
            </DoctorconsoleGrid>
          </DoctorconsoleGrid>
        )} */}

            {/* ── Inline Telemedicine Panel ── */}
            {showTelePanel &&
              (() => {
                const p = state?.patientData;
                const telePatientId = p?.patient_id || "";
                const teleRoomId = `hlthtek-${telePatientId || Date.now()}`;
                const telePatientLink = `${window.location.origin}/doctor/tele-console-patient?room=${encodeURIComponent(teleRoomId)}&name=${encodeURIComponent(p?.name || "Patient")}`;
                return (
                  <DoctorconsoleGrid item xs={12} sx={{ mb: 2 }}>
                    <div
                      style={{
                        background: "#fff",
                        borderRadius: 12,
                        boxShadow: "0 2px 12px rgba(14,63,102,0.10)",
                        border: "1.5px solid #177f97",
                        overflow: "hidden",
                      }}
                    >
                      {/* Panel header */}
                      <div
                        style={{
                          background: "#0E3F66",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 20px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            fontWeight: 700,
                            fontSize: 15,
                          }}
                        >
                          <VideoCallIcon style={{ fontSize: 20 }} />
                          Telemedicine — {p?.name || "Patient"}
                          {p?.age ? ` · Age ${p.age}` : ""}
                          {p?.gender ? ` · ${p.gender}` : ""}
                        </div>
                        <button
                          onClick={() => {
                            setShowTelePanel(false);
                            setTeleCallStarted(false);
                          }}
                          style={{
                            background: "rgba(255,255,255,0.15)",
                            border: "none",
                            color: "#fff",
                            borderRadius: 6,
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontWeight: 600,
                            fontSize: 13,
                          }}
                        >
                          ✕ Close
                        </button>
                      </div>

                      <div style={{ padding: "14px 20px" }}>
                        {/* Patient join link */}
                        <div style={{ marginBottom: 12 }}>
                          <div
                            style={{
                              fontSize: 11,
                              color: "#888",
                              fontWeight: 600,
                              textTransform: "uppercase",
                              letterSpacing: 0.4,
                              marginBottom: 6,
                            }}
                          >
                            Patient Join Link
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              background: "#f5f7fa",
                              border: "1px solid #dde3ec",
                              borderRadius: 8,
                              padding: "7px 12px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: 12,
                                color: "#333",
                                flex: 1,
                                wordBreak: "break-all",
                              }}
                            >
                              {telePatientLink}
                            </span>
                            <button
                              onClick={() => {
                                navigator.clipboard
                                  .writeText(telePatientLink)
                                  .then(() => {
                                    setTeleCopied(true);
                                    setTimeout(
                                      () => setTeleCopied(false),
                                      2000,
                                    );
                                  });
                              }}
                              style={{
                                background: "#0E3F66",
                                color: "#fff",
                                border: "none",
                                borderRadius: 6,
                                padding: "5px 12px",
                                fontSize: 12,
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                                flexShrink: 0,
                                fontWeight: 600,
                              }}
                            >
                              <ContentCopyIcon style={{ fontSize: 14 }} />
                              {teleCopied ? "Copied!" : "Copy"}
                            </button>
                          </div>
                          <div
                            style={{
                              fontSize: 11,
                              color: "#aaa",
                              marginTop: 4,
                            }}
                          >
                            Share this link with the patient to join the video
                            call.
                          </div>
                        </div>

                        {/* Doctor's Room */}
                        <div style={{ marginBottom: 12 }}>
                          <Room
                            roomId={teleRoomId}
                            userName={`${userInfo?.name || state?.doctorData?.name || "Doctor"}`}
                          />
                        </div>

                        {/* End Call Button */}
                        <button
                          onClick={() => {
                            setShowTelePanel(false);
                            setTeleCallStarted(false);
                          }}
                          style={{
                            background: "#c62828",
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            padding: "9px 24px",
                            fontSize: 14,
                            fontWeight: 700,
                            cursor: "pointer",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 8,
                          }}
                        >
                          ■ End Call
                        </button>
                      </div>
                    </div>
                  </DoctorconsoleGrid>
                );
              })()}

            <DoctorconsoleGrid
              container
              item
              xs={12}
              sx={{
                // maxHeight: "800px",
                overflowY: "auto",
                padding: "10px",
                marginTop: 2,
                position: "relative",
              }}
            >
              {featureFlags.transcription && voiceTranscripton && (
                <DoctorconsoleGrid item xs={12} sx={{ marginBottom: 1 }}>
                  <StyledAccordion
                    title="Transcription"
                    expanded={isOuterExpanded("Transcription")}
                    onChange={handleOuterAccordionChange("Transcription")}
                  >
                    <AccordionDetails>
                      <Transcription
                        activeSection={activeSection == "Transcription"}
                        data={voiceTranscripton}
                      />
                    </AccordionDetails>
                  </StyledAccordion>
                </DoctorconsoleGrid>
              )}
              <DoctorConsoleSectionsList
                activeSection={activeSection}
                suggestions={suggestions}
                isSectionExpanded={isOuterExpanded}
                handleOuterAccordionChange={handleOuterAccordionChange}
                handleActiveSectionChange={handleActiveSectionChange}
                selectedSectionsData={selectedSectionsData}
                updateSectionData={updateSectionData}
                medicalBackground={medicalBackground}
                updateMedicalBackground={updateMedicalBackground}
                vitals={vitals}
                setVitals={setVitals}
                dentalData={dentalData}
                setDentalData={setDentalData}
                bloodGroup={bloodGroup}
                setBloodGroup={setBloodGroup}
                otherExaminations={otherExaminations}
                setOtherExaminations={setOtherExaminations}
                aiSuggestionToggle={aiSuggestionToggle}
                ruleSuggestionToggle={ruleSuggestionToggle}
                handleCrossButtonClick={handleCrossButtonClick}
                handleStartRecordingForIndividualSection={
                  handleStartRecordingForIndividualSection
                }
                handleStopRecordingForIndividualSection={
                  handleStopRecordingForIndividualSection
                }
                isAiEnabled={isAiEnabled}
                routeAutoData={routeAutoData}
                followUpError={followUpError}
                referralError={referralError}
                ipdReferralError={ipdReferralError}
                setFollowUpError={setFollowUpError}
                setReferralError={setReferralError}
                setIpdReferralError={setIpdReferralError}
                state={state}
                isS3ModalOpen={isS3ModalOpen}
                setIsS3ModalOpen={setIsS3ModalOpen}
                activeHistorySection={activeHistorySection}
                setActiveHistorySection={setActiveHistorySection}
              />
            </DoctorconsoleGrid>

            <Grid
              container
              spacing={2} // controls gap between items
              sx={{
                padding: "10px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              {/* <Grid item>
              <Fab
                variant="extended"
                sx={{
                  position: "relative",
                  color: "#fff",
                  backgroundColor: "#21cdc0",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "-100%",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#26365e",
                    zIndex: -1,
                    transition: "left 0.1s ease-in-out",
                  },
                  "&:hover::before": {
                    left: 0,
                  },

                  textTransform: "none",
                  marginRight: "10px",
                }}
                onClick={prescriptionSubmitHandler}
              >
                Submit
              </Fab>
            </Grid> */}
              {/* Submit / Preview / Save Draft — Save Draft hidden after OpConsultationSubmited */}
              <Grid item xs={OpConsultationSubmited ? 3 : 4}>
                <StyledButton
                  bgColor="#125386"
                  borderColor="#0E3F66"
                  textColor="#FFFFFF"
                  onClick={prescriptionSubmitHandler}
                  disabled={isSubmittingPrescription}
                  variant="contained"
                  sx={{ width: "100%", fontSize: { xs: "0.8rem", sm: "1rem" } }}
                >
                  {isSubmittingPrescription ? "Submitting..." : "Submit"}
                </StyledButton>
              </Grid>

              <Grid item xs={OpConsultationSubmited ? 3 : 4}>
                <StyledButton
                  bgColor="#BAF0EB"
                  borderColor="#21CDC0"
                  textColor="#000000"
                  onClick={openPreviewModal}
                  variant="contained"
                  sx={{ width: "100%", fontSize: { xs: "0.8rem", sm: "1rem" } }}
                >
                  Preview
                </StyledButton>
              </Grid>

              {!OpConsultationSubmited && (
                <Grid item xs={4}>
                  {/* POST prescription_draft/ — persists draft to server for this appointment */}
                  <StyledButton
                    bgColor="#E8F4FC"
                    borderColor="#125386"
                    textColor="#125386"
                    onClick={handleSavePrescriptionDraft}
                    variant="contained"
                    disabled={isSavingPrescriptionDraft}
                    sx={{
                      width: "100%",
                      fontSize: { xs: "0.8rem", sm: "1rem" },
                    }}
                  >
                    {isSavingPrescriptionDraft ? "Saving..." : "Save Draft"}
                  </StyledButton>
                </Grid>
              )}

              {OpConsultationSubmited && (
                <>
                  {/* <Grid item xs={3}>
                  <StyledButton
                    bgColor="#FFD2B0"
                    borderColor="#FF8C33"
                    textColor="#FF6F00"
                    // onClick={handlePrint}
                    onClick={handleClickPrint}
                    variant="contained"
                    sx={{
                      width: "100%",
                      fontSize: { xs: "0.8rem", sm: "1rem" },
                    }}
                  >
                    Print
                  </StyledButton>
                  <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                  >
                    <List>
                      <ListItem disablePadding>
                        <ListItemButton onClick={() => handlePrintOption(true)}>
                          <ListItemText primary="Print with Headers" />
                        </ListItemButton>
                      </ListItem>
                      <ListItem disablePadding>
                        <ListItemButton
                          onClick={() => handlePrintOption(false)}
                        >
                          <ListItemText primary="Print without Headers" />
                        </ListItemButton>
                      </ListItem>
                    </List>
                  </Popover>
                </Grid> */}
                  <Grid item xs={3}>
                    <StyledButton
                      bgColor="#FFD2B0"
                      borderColor="#FF8C33"
                      textColor="#FF6F00"
                      // onClick={handlePrint}
                      onClick={handleClickPrint}
                      variant="contained"
                      sx={{
                        width: "100%",
                        fontSize: { xs: "0.8rem", sm: "1rem" },
                      }}
                    >
                      Print
                    </StyledButton>

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      PaperProps={{
                        style: {
                          width: anchorEl ? anchorEl.offsetWidth : undefined, // match button width
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => handlePrint(true, "OpConsultation")}
                      >
                        OP consultation with Letterhead
                      </MenuItem>
                      <MenuItem
                        onClick={() => handlePrint(false, "OpConsultation")}
                      >
                        OP consultation without Letterhead
                      </MenuItem>
                      <MenuItem
                        onClick={() => handlePrint(true, "Prescription")}
                      >
                        Prescription with Letterhead
                      </MenuItem>
                      <MenuItem
                        onClick={() => handlePrint(false, "Prescription")}
                      >
                        Prescription without Letterhead
                      </MenuItem>
                    </Menu>
                  </Grid>

                  <Grid item xs={3}>
                    <StyledButton
                      bgColor="#8DC63F"
                      borderColor="#5DAA60"
                      textColor="#FFFFFF"
                      onClick={handleCompleteAppointment}
                      variant="contained"
                      sx={{
                        width: "100%",
                        fontSize: { xs: "0.8rem", sm: "1rem" },
                      }}
                    >
                      Complete
                    </StyledButton>
                  </Grid>
                </>
              )}
            </Grid>
          </Card>
          <DoctorconsoleGrid item xs={12}>
            <Disclaimer />
          </DoctorconsoleGrid>
          <DoctorconsoleGrid container spacing={2} direction="column">
            {/* Patient Summary Section */}
            {/* {isAiEnabled && !drawerOpen && !summaryDrawerOpen && (
            <DoctorconsoleGrid item>
              <Tooltip title="Patient Summary">
                <Box
                  sx={{
                    position: "fixed",
                    bottom: 214, // above the FAB
                    right: 16,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#26365e",
                    color: "#fff",
                    borderRadius: "30px",
                    cursor: "pointer",
                    padding: "8px 12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    zIndex: 1300,
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.05)",
                    },
                  }}
                  onClick={handleOpenPatientSummaryModal}
                >
                  <PatientSummaryIcon width={32} height={32} />
                </Box>
              </Tooltip>
            </DoctorconsoleGrid>
          )} */}

            {/* Voice e-prescription Section */}
            {/* {isAiEnabled && !drawerOpen && !summaryDrawerOpen && (
            <DoctorconsoleGrid item>
              <Tooltip title="Speak here">
                <Box
                  sx={{
                    position: "fixed",
                    bottom: 150, // above the FAB
                    right: 16,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#26365e",
                    color: "#fff",
                    borderRadius: "30px",
                    cursor: "pointer",
                    padding: "8px 12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    zIndex: 1300,
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.05)",
                    },
                  }}
                  onClick={handleOpenMicModal}
                >
                  <BotListeningIcon width={32} height={32} />
                </Box>
              </Tooltip>
            </DoctorconsoleGrid>
          )} */}

            {/* Past Records Section */}
            {/* <DoctorconsoleGrid item> */}
            {/* <Tooltip title="Past Records">
              <Fab
                sx={{
                  color: "#fff",
                  backgroundColor: "#21cdc0",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "-100%",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#26365e",
                    zIndex: -1,
                    transition: "left 0.3s ease-in-out",
                  },
                  "&:hover::before": {
                    left: 0,
                  },
                  textTransform: "none",
                  position: "fixed",
                  bottom: 86,
                  right: 16,
                }}
                aria-label="add"
                onClick={handleDrawerOpen}
                variant="extended"
              >
                <ArrowBackIcon />
                Past Records
              </Fab>
            </Tooltip> */}

            {/* <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={handleDrawerClose}
              PaperProps={{
                sx: {
                  width: {
                    xs: "100%", // 100% width on extra-small screens
                    md: "60%", // 80% width on small and medium screens
                    lg: "50%", // 60% width on large screens
                  },
                },
              }}
            >
              <div>
                <StyledButton onClick={handleDrawerClose}>
                  <ArrowForwardIcon />
                </StyledButton>

                <List
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  {["Past Visits", "ABDM Records"].map((section, index) => (
                    <ListItemButton
                      key={index}
                      selected={selectedMedicalSection === section}
                      disabled={section === "ABDM Records" && !isAbdmEnabled}
                      style={{
                        borderBottom:
                          selectedMedicalSection === section
                            ? "5px solid #21cdc0"
                            : "none",
                        width: "33.33%",
                      }}
                      onClick={() => {
                        if (section === "ABDM Records" && !isAbdmEnabled) {
                          // If isAbdmEnabled is false, don't handle the click event
                          return;
                        } else {
                          handleMedicalSectionClick(section);
                        }
                      }}
                    >
                      <ListItemText primary={section} />
                    </ListItemButton>
                  ))}
                </List>
                
                <div style={{ margin: "50px" }}>
                  <h3 className="console-heading">{selectedMedicalSection}</h3>
                  {selectedMedicalSection === "Past Visits" ? (
                    <PastVisits
                      patientData={state?.patientData}
                      fhirArrayData={s3BucketFhir}
                      careContextList={care_context_list}
                      selectedCareContext={selectedContextForRetrieveFhir}
                      onSubmitFhirArray={handleFhirArray}
                    />
                  ) : (
                    <></>
                  )}
                  {selectedMedicalSection === "ABDM Records" && (
                    <AbdmRecords organizedArray={abdmData} />
                  )}
                </div>
                
              </div>
            </Drawer> */}
            {/* </DoctorconsoleGrid> */}

            {/* AI Section */}

            <DoctorconsoleGrid item>
              {(featureFlags.voicePrescription || featureFlags.patient360) && (
                <Box
                  sx={{
                    position: "fixed",
                    bottom: 16,
                    right: 16,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    zIndex: 9995,
                  }}
                >
                  <Zoom in={floatingMenuOpen}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        mb: 1,
                      }}
                    >
                      {featureFlags.voicePrescription && (
                        <Tooltip title="Voice Prescription" placement="left">
                          <Fab
                            variant="extended"
                            // size="medium"
                            // color="primary"
                            onClick={handleOpenMicModal}
                            sx={{
                              background: "#fff",
                              color: "#000",
                              borderRadius: "25px",
                              height: "48px",
                              padding: "0 16px",
                              minWidth: "auto",
                              boxShadow: "-1px -2px 20px 2px #00000040 inset",
                              textTransform: "none",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: 1,
                            }}
                          >
                            <Icon name="voicePrescriptionIcon" size={32} />
                            <Typography
                              sx={{
                                color: "#173ECA",
                                fontWeight: 500,
                                lineHeight: "100%",
                              }}
                            >
                              Voice Prescription
                            </Typography>
                          </Fab>
                        </Tooltip>
                      )}
                      {featureFlags.patient360 && (
                        <Tooltip title="Patient 360" placement="left">
                          <Fab
                            variant="extended"
                            // size="medium"
                            // color="primary"
                            onClick={handleOpenPatientSummaryModal}
                            sx={{
                              background: "#fff",
                              color: "#000",
                              borderRadius: "25px",
                              height: "48px",
                              padding: "0 16px",
                              minWidth: "auto",
                              boxShadow: "-1px -2px 20px 2px #00000040 inset",
                              textTransform: "none",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: 1,
                            }}
                          >
                            <Icon name="patient360Icon" size={32} />
                            <Typography
                              sx={{
                                color: "#173ECA",
                                fontWeight: 500,
                                lineHeight: "100%",
                              }}
                            >
                              Patient 360
                            </Typography>
                          </Fab>
                        </Tooltip>
                      )}
                    </Box>
                  </Zoom>
                </Box>
              )}

              <Drawer
                anchor="right"
                open={summaryDrawerOpen}
                onClose={handleSummaryDrawerClose}
                PaperProps={{
                  sx: {
                    width: {
                      xs: "100%", // 100% width on extra-small screens
                      md: "60%", // 80% width on small and medium screens
                      lg: "50%", // 60% width on large screens
                    },
                  },
                }}
              >
                <StyledButton onClick={handleSummaryDrawerClose}>
                  <ArrowForwardIcon />
                </StyledButton>
                <Grid container spacing={2} sx={{ margin: "50px" }}>
                  <Grid item xs={12}>
                    <h3>Transcription</h3>
                    <div>
                      {" "}
                      {/* Add your transcription editor or content here */}
                    </div>
                  </Grid>

                  {/* Buttons */}
                  <Grid container spacing={2} item xs={12}>
                    <Grid item xs={6} md={2}>
                      <StyledButton fullWidth onClick={submitSummary}>
                        Submit
                      </StyledButton>
                    </Grid>
                    <Grid item xs={6} md={2}>
                      <StyledButton fullWidth onClick={resetTextArea}>
                        Reset
                      </StyledButton>
                    </Grid>
                    <Grid item xs={6} md={2}>
                      <StyledButton fullWidth onClick={startListening}>
                        Start Listening
                      </StyledButton>
                    </Grid>
                    <Grid item xs={6} md={2}>
                      <StyledButton
                        fullWidth
                        onClick={SpeechRecognition.stopListening}
                      >
                        Stop Listening
                      </StyledButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Drawer>
            </DoctorconsoleGrid>
          </DoctorconsoleGrid>
        </DoctorconsoleGrid>

        <Modal
          open={addCareContextModalOpen}
          onClose={AddCareContextCloseModal}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: "70%", md: "45%" },
              bgcolor: "#FDFDFD",
              borderRadius: "12px",
              boxShadow: 24,
              p: 3,
            }}
          >
            {/* Header */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, fontSize: "20px", color: "#1a1a1a" }}
              >
                Add Visit Purpose
              </Typography>
              <IconButton onClick={AddCareContextCloseModal}>
                <CloseIcon />
              </IconButton>
            </Box>
            {/* Inner Card */}
            <Card
              sx={{
                p: 3,
                borderRadius: "12px",
                boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
                border: "1px solid #B1B1B1",
              }}
            >
              <form onSubmit={handleSubmit3(AddCareContext)}>
                <Box display="flex" gap={2} mb={3}>
                  {/* Patient ID */}
                  <TextField
                    fullWidth
                    value={state?.patientData.patient_id}
                    InputProps={{ readOnly: true }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "6px",
                        "& fieldset": { borderColor: "#154360" }, // blue border
                        "&:hover fieldset": { borderColor: "#154360" },
                        backgroundColor: "#EEEEEE",
                      },
                    }}
                  />

                  {/* Visit Details */}
                  <TextField
                    fullWidth
                    placeholder="Enter Visit Details"
                    {...register3("visit_details", {
                      required: "Visit Details is required.",
                    })}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "6px",
                        "& fieldset": { borderColor: "#154360" }, // blue border
                        "&:hover fieldset": { borderColor: "#154360" },
                      },
                    }}
                  />
                </Box>

                {/* Add Button */}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    backgroundColor: "#0A3D62",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "16px",
                    py: 1.2,
                    "&:hover": { backgroundColor: "#08324f" },
                  }}
                >
                  Add
                </Button>
              </form>
            </Card>
          </Box>
        </Modal>

        <Modal open={previewPrescription} onClose={closePreviewModal}>
          <Box
            className="preview-modal-box"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <IconButton onClick={closePreviewModal}>
                <CloseIcon />
              </IconButton>
            </div>
            <Box
              sx={{ borderBottom: 1, borderColor: "divider", flexShrink: 0 }}
            >
              <Tabs
                value={previewTab}
                onChange={(_, newValue) => setPreviewTab(newValue)}
                variant="fullWidth"
                textColor="inherit"
                sx={{
                  minHeight: 40,
                  "& .MuiTab-root": {
                    minHeight: 40,
                    py: 0.5,
                  },
                }}
                TabIndicatorProps={{
                  style: {
                    display: "none",
                    boxShadow: "0 4px 4px 0 #C7C7CC inset",
                  },
                }}
              >
                <Tab
                  label="OP Consultation"
                  sx={{
                    fontWeight: "bold",
                    bgcolor: previewTab === 0 ? "#E9FAF9" : "transparent",
                    boxShadow: "0 4px 4px 0 #C7C7CC inset",
                  }}
                />
                <Tab
                  label="Prescription"
                  sx={{
                    fontWeight: "bold",
                    bgcolor: previewTab === 1 ? "#E9FAF9" : "transparent",
                    boxShadow: "0 4px 4px 0 #C7C7CC inset",
                  }}
                />
              </Tabs>
            </Box>
            <Box sx={{ flex: 1, minHeight: 0, overflow: "auto", py: 1 }}>
              {previewTab === 0 ? (
                <PrescriptionPdfPdf
                  preview
                  selectedSectionsData={selectedSectionsData}
                  historyDetails={medicalBackground}
                  sectionsContent={sectionsContent}
                  doctorData={state?.doctorData}
                  hasVitalValue={hasVitalValue}
                  vitals={vitals}
                  hasDentalData={hasDentalData}
                  dentalData={dentalData}
                  prescribedMedicines={selectedSectionsData["Medications"]}
                  patientData={state?.patientData}
                  bloodGroup={bloodGroup}
                  otherExaminations={otherExaminations}
                  selectedContext={selectedContext}
                  selectedContextDisplay={selectedContextDisplay}
                  followUpError={followUpError}
                  referralError={referralError}
                  departments={departments}
                  dateForAppointment={state?.dateForAppointment}
                  startTime={startTime}
                />
              ) : (
                <PrintPrescriptionforButtonDropdown
                  preview
                  selectedSectionsData={selectedSectionsData}
                  historyDetails={medicalBackground}
                  sectionsContent={sectionsContent}
                  doctorData={state?.doctorData}
                  hasVitalValue={hasVitalValue}
                  vitals={vitals}
                  hasDentalData={hasDentalData}
                  dentalData={dentalData}
                  prescribedMedicines={selectedSectionsData["Medications"]}
                  patientData={state?.patientData}
                  bloodGroup={bloodGroup}
                  otherExaminations={otherExaminations}
                  selectedContext={selectedContext}
                  selectedContextDisplay={selectedContextDisplay}
                  followUpError={followUpError}
                  referralError={referralError}
                  departments={departments}
                  dateForAppointment={state?.dateForAppointment}
                  startTime={startTime}
                />
              )}
            </Box>
          </Box>
        </Modal>

        {featureFlags.voicePrescription && (
          <VoiceInputModal
            openMicModal={openMicModal}
            handleCloseMicModal={handleCloseMicModal}
            language={language}
            setLanguage={setLanguage}
            sectionToEdit={sectionToEdit}
            setSectionToEdit={setSectionToEdit}
            isRecording={isRecording}
            handleStartRecording={handleStartRecording}
            handleStopRecording={handleStopRecording}
            streamRef={streamRef}
            audioBlob={audioBlob}
            setAudioBlob={setAudioBlob}
            handleSubmitRecording={handleSubmitRecording}
            handleSubmitRecordingEdit={handleSubmitRecordingForEdit}
            handleSubmitTextPrescription={handleSubmitTextPrescription}
            isSubmittingTextPrescription={isSubmittingTextPrescription}
            handlePauseRecording={handlePauseRecording}
            handleResumeRecording={handleResumeRecording}
            isPaused={isPaused}
            voiceTranscripton={voiceTranscripton}
            limitMessage={limitMessage}
            patientId={state?.patientData?.patient_id}
            authToken={authToken}
            backendUrl={REACT_APP_BACKEND_ROUTE_URL}
            facilityName={sessionStorage.getItem("facility_name") || ""}
            transcriptionEnabled={featureFlags.transcription}
          />
        )}

        {/* <PatientSummaryModal
        open={openPatientSummaryModal}
        handleClose={handleClosePatientSummaryModal}
        patientSummary={patientSummary?.medical_summary}
        totalRecords={patientSummary?.total_records}
        orgCode={sessionStorage.getItem("ORG_CODE")}
        patientId={state?.patientData.patient_id}
      /> */}
        <Patient360Modal
          open={openPatientSummaryModal}
          handleClose={handleClosePatientSummaryModal}
          patientSummary={patientSummary?.medical_summary}
          isLoadingSummary={isLoadingSummary}
          totalRecords={patientSummary?.total_records}
          orgCode={sessionStorage.getItem("ORG_CODE")}
          patientId={state?.patientData.patient_id}
          abdmData={abdmData}
          patientData={state?.patientData}
          s3BucketFhir={s3BucketFhir}
          care_context_list={care_context_list}
          selectedContextForRetrieveFhir={selectedContextForRetrieveFhir}
          handleFhirArray={handleFhirArray}
          isAbdmEnabled={isAbdmEnabled}
          isAiEnabled={isAiEnabled}
        />

        <CaseSheetModal
          open={isCaseSheetOpen}
          onClose={() => setIsCaseSheetOpen(false)}
          onAfterSave={() => {
            handleGetPatientHistoryData();
          }}
          appointment={
            state?.patientData?.patient_id
              ? {
                  patient: state.patientData.patient_id,
                  patient_name: state.patientData.name,
                  name: state.patientData.name,
                  appointment_id: state?.appointmentId,
                }
              : null
          }
          patientData={state?.patientData}
          doctorData={{ doctor_id: consoleDoctorId }}
        />

        <PastRecordsModal
          openPastRecordsModal={openPastRecordsModal}
          handleClosePastRecordsModal={handleClosePastRecordsModal}
          patientData={state?.patientData}
          s3BucketFhir={s3BucketFhir}
          care_context_list={care_context_list}
          selectedContextForRetrieveFhir={selectedContextForRetrieveFhir}
          handleFhirArray={handleFhirArray}
          abdmData={abdmData}
        />

        <Snackbar
          open={openSnackBar}
          autoHideDuration={6000}
          onClose={handleCloseSnackBar}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <Alert
            onClose={handleCloseSnackBar}
            severity="error"
            sx={{ width: "100%" }}
          >
            No Data Present For Preview!
          </Alert>
        </Snackbar>

        <div
          id="transcribeId"
          style={{ position: "absolute", left: "-9999px" }}
        >
          <DoctorconsoleGrid container>
            {/* First three grids */}
            <DoctorconsoleGrid item xs={12} sm={6} md={6} padding={2}>
              <Typography variant="h4">Transcription</Typography>
            </DoctorconsoleGrid>

            <DoctorconsoleGrid
              item
              xs={12}
              sm={6}
              md={6}
              textAlign="right"
              padding={2}
            >
              <img
                src={Navlogo}
                className="logo-dark logo-img"
                alt="logo"
                width="100px"
                height="60px"
                style={{ paddingBottom: "3px", paddingTop: "5px" }}
              />
            </DoctorconsoleGrid>

            {/* Last grid in a new row */}
            <DoctorconsoleGrid item xs={12}>
              <DoctorconsoleGrid container>
                <DoctorconsoleGrid
                  item
                  xs={9}
                  sm={9}
                  md={9}
                  padding={2}
                  // sx={{
                  //   borderTop: "1px solid #ccc",
                  //   borderBottom: "1px solid #ccc",
                  // }}
                >
                  <Typography variant="subtitle1" color="black">
                    <b>{displayDoctorName(state?.doctorData)}</b>
                  </Typography>
                  <Typography variant="subtitle1" color="black">
                    <b>{state?.doctorData?.qualifications}</b>
                  </Typography>
                  <Typography variant="subtitle1" color="black">
                    Doctor Id: <b>{state?.doctorData?.doctor_id}</b>
                  </Typography>
                  <Typography variant="subtitle1" color="black">
                    <b>{state?.doctorData?.department}</b>
                    {state?.doctorData?.specialization &&
                      ` - ${state?.doctorData?.specialization}`}
                  </Typography>
                </DoctorconsoleGrid>
                <DoctorconsoleGrid
                  item
                  xs={3}
                  sm={3}
                  md={3}
                  textAlign="right"
                  padding={2}
                >
                  <Typography variant="subtitle1" color="black">
                    Date:{" "}
                    <b>
                      {state?.dateForAppointment?.toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "numeric",
                        year: "numeric",
                      })}
                    </b>
                  </Typography>
                </DoctorconsoleGrid>
              </DoctorconsoleGrid>
            </DoctorconsoleGrid>
            <DoctorconsoleGrid item xs={12}>
              <DoctorconsoleGrid
                container
                sx={{
                  borderTop: "1px solid #ccc",
                  borderBottom: "1px solid #ccc",
                  marginTop: "20px",
                }}
              >
                <DoctorconsoleGrid item xs={12} sm={6} md={6} padding={2}>
                  <Typography
                    variant="subtitle1"
                    color="black"
                    style={{ textTransform: "uppercase" }}
                  >
                    Patient's Name:{" "}
                    <b>{displayPatientName(state?.patientData?.name)}</b>
                  </Typography>
                  <Typography variant="subtitle1" color="black">
                    Age: <b>{state?.patientData.age}</b>
                  </Typography>
                  <Typography variant="subtitle1" color="black">
                    Gender: <b>{state?.patientData.gender}</b>
                  </Typography>
                </DoctorconsoleGrid>
                <DoctorconsoleGrid item xs={12} sm={6} md={6} padding={2}>
                  <Typography variant="subtitle1" color="black">
                    Clinic Address:{" "}
                    <b>
                      {[
                        sessionStorage.getItem("facilityAddressLine1"),
                        sessionStorage.getItem("facilityAddressLine2"),
                        sessionStorage.getItem("facilityAddressLine3"),
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    </b>
                  </Typography>

                  <Typography variant="subtitle1" color="black">
                    Contact Number: <b>{state?.patientData.phone_no}</b>
                  </Typography>
                  <Typography variant="subtitle1" color="black">
                    Visit Purpose: <b>{selectedContextDisplay}</b>
                  </Typography>
                </DoctorconsoleGrid>
              </DoctorconsoleGrid>
            </DoctorconsoleGrid>
          </DoctorconsoleGrid>

          <JoditEditor value={summary} config={summaryConfig} />
        </div>
        <PrintPrescriptionforButtonDropdown
          ref={printPrescRef}
          selectedSectionsData={selectedSectionsData}
          historyDetails={medicalBackground}
          sectionsContent={sectionsContent}
          doctorData={state?.doctorData}
          hasVitalValue={hasVitalValue}
          vitals={vitals}
          hasDentalData={hasDentalData}
          dentalData={dentalData}
          prescribedMedicines={selectedSectionsData["Medications"]}
          patientData={state?.patientData}
          id="prescription-preview"
          bloodGroup={bloodGroup}
          otherExaminations={otherExaminations}
          selectedContext={selectedContext}
          selectedContextDisplay={selectedContextDisplay}
          followUpError={followUpError}
          referralError={referralError}
          departments={departments}
          dateForAppointment={state?.dateForAppointment}
          startTime={startTime}
          // showFooter={false}
          // useBackgroundTemplate={true}
        />

        <PrintPrescription
          ref={printRef}
          selectedSectionsData={selectedSectionsData}
          historyDetails={medicalBackground}
          sectionsContent={sectionsContent}
          doctorData={state?.doctorData}
          hasVitalValue={hasVitalValue}
          vitals={vitals}
          hasDentalData={hasDentalData}
          dentalData={dentalData}
          prescribedMedicines={selectedSectionsData["Medications"]}
          patientData={state?.patientData}
          id="prescription-preview"
          bloodGroup={bloodGroup}
          otherExaminations={otherExaminations}
          selectedContext={selectedContext}
          selectedContextDisplay={selectedContextDisplay}
          followUpError={followUpError}
          referralError={referralError}
          departments={departments}
          dateForAppointment={state?.dateForAppointment}
          startTime={startTime}
        />
        <WellnessPdf
          ref={wellnessPdfRef}
          selectedSectionsData={selectedSectionsData}
          historyDetails={medicalBackground}
          sectionsContent={sectionsContent}
          doctorData={state?.doctorData}
          hasVitalValue={hasVitalValue}
          vitals={vitals}
          hasDentalData={hasDentalData}
          dentalData={dentalData}
          prescribedMedicines={selectedSectionsData["Medications"]}
          patientData={state?.patientData}
          id="prescription-preview"
          bloodGroup={bloodGroup}
          otherExaminations={otherExaminations}
          selectedContext={selectedContext}
          selectedContextDisplay={selectedContextDisplay}
          followUpError={followUpError}
          referralError={referralError}
          departments={departments}
          dateForAppointment={state?.dateForAppointment}
          startTime={startTime}
        />
        <PrescriptionPdf
          ref={prescriptionPdfRef}
          selectedSectionsData={selectedSectionsData}
          historyDetails={medicalBackground}
          sectionsContent={sectionsContent}
          doctorData={state?.doctorData}
          hasVitalValue={hasVitalValue}
          vitals={vitals}
          hasDentalData={hasDentalData}
          dentalData={dentalData}
          prescribedMedicines={selectedSectionsData["Medications"]}
          patientData={state?.patientData}
          id="prescription-preview"
          bloodGroup={bloodGroup}
          otherExaminations={otherExaminations}
          selectedContext={selectedContext}
          selectedContextDisplay={selectedContextDisplay}
          followUpError={followUpError}
          referralError={referralError}
          departments={departments}
          dateForAppointment={state?.dateForAppointment}
          startTime={startTime}
        />
        <PrescriptionPdfPdf //for op consultation
          ref={PrescriptionPdfPdfRef}
          selectedSectionsData={selectedSectionsData}
          historyDetails={medicalBackground}
          sectionsContent={sectionsContent}
          doctorData={state?.doctorData}
          hasVitalValue={hasVitalValue}
          vitals={vitals}
          hasDentalData={hasDentalData}
          dentalData={dentalData}
          prescribedMedicines={selectedSectionsData["Medications"]}
          patientData={state?.patientData}
          id="prescription-preview"
          bloodGroup={bloodGroup}
          otherExaminations={otherExaminations}
          selectedContext={selectedContext}
          selectedContextDisplay={selectedContextDisplay}
          followUpError={followUpError}
          referralError={referralError}
          departments={departments}
          dateForAppointment={state?.dateForAppointment}
          startTime={startTime}
        />
      </ThemeProvider>
    </DoctorConsoleConfigProvider>
  );
};

export default DoctorConsole;
